var TEMPLATES_JSON_URL = 'https://cdn.shopify.com/s/files/1/0771/2125/7526/files/B1_PRODUCTION_TEMPLATES.json?v=1791602756';
var GIFT_TEMPLATE_URL = '';
var GIFT_TEMPLATE_INTEGRITY = '';
var templatesPromise = null;
var RL_STORE_FILES_PREFIX = '/s/files/1/0771/2125/7526/';
var RL_GIFT_STORE_ORIGIN_SHA256 = 'fc117f2e0aed67e4a924d63ac281a83fd2783f2742089981f6dca9104ad48969';
function rlSha256Hex(text) {
  var subtle = window.crypto && window.crypto.subtle;
  if (!subtle) return Promise.resolve('');
  return subtle.digest('SHA-256', new TextEncoder().encode(text)).then(function (buf) {
    return Array.prototype.map.call(new Uint8Array(buf), function (b) { return (b < 16 ? '0' : '') + b.toString(16); }).join('');
  });
}
function rlIsAllowedFile(v) {
  if (rlIsStoreFile(v)) return Promise.resolve(true);
  var u;
  try { u = new URL(v); } catch (e) { return Promise.resolve(false); }
  if (u.protocol !== 'https:' || u.username || u.password || u.port) return Promise.resolve(false);
  return rlSha256Hex(u.origin).then(function (hex) { return hex === RL_GIFT_STORE_ORIGIN_SHA256; });
}
function rlIsStoreFile(v) {
  if (typeof v !== 'string') return false;
  try {
    var u = new URL(v);
    return u.protocol === 'https:' && u.hostname === 'cdn.shopify.com' &&
      !u.username && !u.password && !u.port &&
      u.pathname.indexOf(RL_STORE_FILES_PREFIX) === 0;
  } catch (e) { return false; }
}
function rlValidTemplates(m) {
  if (!m || typeof m !== 'object' || Array.isArray(m)) throw new Error('the list must be a JSON object { "current": ..., "releases": {...} }');
  if (typeof m.current !== 'string' || !m.current) throw new Error('"current" is missing or not text (found: ' + JSON.stringify(m.current) + ')');
  if (!m.releases || typeof m.releases !== 'object') throw new Error('"releases" is missing or not an object');
  var r = m.releases[m.current];
  if (!r || typeof r !== 'object') throw new Error('"current" is "' + m.current + '" but releases has no such key (it has: ' + Object.keys(m.releases).join(', ') + ')');
  if (typeof r.integrity !== 'string' || r.integrity.indexOf('sha384-') !== 0) throw new Error('release "' + m.current + '": "integrity" must be text starting with sha384- (found: ' + JSON.stringify(r.integrity) + ')');
  return r;
}
function loadTemplates() {
  if (!templatesPromise) {
    templatesPromise = (TEMPLATES_JSON_URL
      ? rlFetchTimeout(TEMPLATES_JSON_URL, { mode: 'cors', credentials: 'omit', cache: 'no-cache' }, 5000)
          .then(function (res) { return res.json(); })
      : Promise.reject(new Error('TEMPLATES_JSON_URL is not set'))
    ).then(function (m) {
      var r = rlValidTemplates(m);
      return rlIsAllowedFile(r.path).then(function (ok) {
        if (!ok) throw new Error('release "' + m.current + '": "path" must be a file in this store\'s Shopify Files or the gift file storage (found: ' + JSON.stringify(r.path) + ')');
        GIFT_TEMPLATE_URL = r.path;
        GIFT_TEMPLATE_INTEGRITY = r.integrity;
      });
    }).catch(function (err) {
      templatesPromise = null;
      if (window.console) console.warn('[Riffloom] templates list could not be loaded:', err && err.message || err);
      throw err;
    });
  }
  return templatesPromise;
}
loadTemplates().catch(function () {});
var giftTemplatePromise = null;

function rlFetchTimeout(url, opts, ms) {
  var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
  var timer = null;
  if (ctrl) { opts.signal = ctrl.signal; timer = setTimeout(function () { ctrl.abort(); }, ms); }
  return fetch(url, opts).then(function (res) {
    if (timer) clearTimeout(timer);
    if (!res.ok) throw new Error('HTTP ' + res.status);
    return res;
  }, function (err) {
    if (timer) clearTimeout(timer);
    throw err;
  });
}
function rlBufToBase64(buf) {
  var bytes = new Uint8Array(buf), bin = '';
  for (var i = 0; i < bytes.length; i += 0x8000) {
    bin += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  }
  return btoa(bin);
}
function rlVerifyTemplate(buf) {
  var subtle = window.crypto && window.crypto.subtle;
  if (!subtle) return Promise.reject(new Error('Cannot verify template (no crypto.subtle)'));
  return subtle.digest('SHA-384', buf).then(function (digest) {
    if ('sha384-' + rlBufToBase64(digest) !== GIFT_TEMPLATE_INTEGRITY) {
      throw new Error('Template integrity mismatch');
    }
    return new TextDecoder('utf-8').decode(buf);
  });
}
function getGiftTemplate() {
  if (!giftTemplatePromise) {
    var attempts = [
      function () {
        return rlFetchTimeout(GIFT_TEMPLATE_URL, { mode: 'cors', credentials: 'omit', integrity: GIFT_TEMPLATE_INTEGRITY }, 15000)
          .then(function (res) { return res.text(); });
      },
      function () {
        return rlFetchTimeout(GIFT_TEMPLATE_URL + (GIFT_TEMPLATE_URL.indexOf('?') < 0 ? '?' : '&') + 'rl=' + Date.now(),
          { mode: 'cors', credentials: 'omit', cache: 'no-store', integrity: GIFT_TEMPLATE_INTEGRITY }, 20000)
          .then(function (res) { return res.text(); });
      },
      function () {
        return rlFetchTimeout(GIFT_TEMPLATE_URL, { mode: 'cors', credentials: 'omit', cache: 'reload' }, 25000)
          .then(function (res) { return res.arrayBuffer(); })
          .then(rlVerifyTemplate);
      }
    ];
    giftTemplatePromise = loadTemplates().then(function () {
      return attempts.reduce(function (chain, attempt, i) {
        return chain.catch(function (prev) {
          if (prev && window.console) console.warn('[Riffloom] gift template attempt ' + i + ' failed:', prev && prev.message || prev);
          return attempt();
        });
      }, Promise.reject(null));
    }).catch(function (err) {
      giftTemplatePromise = null;
      if (window.console) console.warn('[Riffloom] gift template could not be loaded:', err && err.message || err);
      throw err;
    });
  }
  return giftTemplatePromise;
}

(function () {
  function fillCatalogPrices() {
    var nodes = document.querySelectorAll('[data-catalog-price]');
    if (!nodes.length) return;
    var catalog = window.RIFFLOOM_CATALOG || {};
    nodes.forEach(function (el) {
      var key = el.getAttribute('data-catalog-price');
      var entry = catalog[key];
      if (!entry || typeof entry.price !== 'number' || !isFinite(entry.price)) {
        var why;
        if (!window.RIFFLOOM_CATALOG) {
          why = 'window.RIFFLOOM_CATALOG does not exist, so snippets/riffloom-catalog.liquid is not being rendered on this page before custom.js (check theme.liquid and that the snippet file is saved under Snippets).';
        } else if (!entry) {
          why = 'the catalog has no "' + key + '" entry (custom.js and the snippet are out of step).';
        } else {
          why = 'Shopify returned no product/variant for this entry (id: ' + entry.id + ', price: ' + entry.price + '). Check the handles at the top of layout/theme.liquid, and that the product is Active and published to the Online Store sales channel.';
        }
        console.error('[Riffloom] No Shopify price for "' + key + '": ' + why);
        el.textContent = '$X';
        return;
      }
      if (entry.price === 0) {
        el.textContent = el.getAttribute('data-catalog-free') || 'complimentary';
        return;
      }
      var dollars = entry.price / 100;
      var amount = dollars % 1 === 0
        ? dollars.toLocaleString('en-CA')
        : dollars.toLocaleString('en-CA', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      el.textContent = (el.getAttribute('data-catalog-prefix') || '') + '$' + amount + (el.getAttribute('data-catalog-suffix') || '');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillCatalogPrices);
  else fillCatalogPrices();
})();

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var playbarControl = {
    suspend: function () {},
    resume: function () {}
  };

  function slug(text) {
    return String(text).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function withInt(href, intValue) {
    if (!intValue || href.indexOf('#') === 0) return href;
    try {
      var u = new URL(href, window.location.href);
      if (u.origin === window.location.origin && u.pathname === window.location.pathname) return href;
      u.searchParams.set('INT', intValue);
      return u.toString();
    } catch (e) {
      return href;
    }
  }
  function escAttr(text) {
    return String(text).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }
  function trackedLinkHtml(href, label, buttonName, intValue, className, extra) {
    return '<a' + (className ? ' class="' + className + '"' : '') +
      ' href="' + escAttr(withInt(href, intValue)) + '"' +
      ' data-button-name="' + escAttr(buttonName) + '"' + (extra || '') + '>' + label + '</a>';
  }

  (function injectSiteChrome() {
    if (window.RIFFLOOM_BARE_LAYOUT) return;
    if (document.querySelector('.wiz-page')) return;

    if (!window.RIFFLOOM_NO_NAVBAR && !document.querySelector('.rail')) {
      var SITE_URL = 'https://riffloom.com';
      var isHome = window.location.pathname === '/' || window.location.pathname === '';

      var link = function (href, label) {
        var absolute = href.indexOf('#') === 0
          ? (isHome ? href : SITE_URL + '/' + href)
          : href;
        return { href: absolute, label: label };
      };

      var navLinks = [
        link('#home', 'Home'),
        link('#about', 'About'),
        link('#works', 'Featured'),
        link('#how-it-works', 'How it works'),
        link('#occasions', 'Occasions'),
        link('#packages', 'Packages'),
        link('#artists', 'Artists'),
        link('#faq', 'FAQ')
      ];
      var navLinksHtml = navLinks.map(function (l) {
        return trackedLinkHtml(l.href, l.label, 'nav | ' + l.label.toLowerCase(), 'nav-' + slug(l.label));
      }).join('\n    ');

      var markHref = isHome ? '#top' : SITE_URL + '/#top';

      var COMPOSE_URL = 'https://riffloom.com/pages/compose-your-song';
      var ctaHtml = trackedLinkHtml(COMPOSE_URL, 'Compose your piece', 'nav | compose your song', 'nav-compose-your-song', 'rail__cta');
      var topbarCtaHtml = trackedLinkHtml(COMPOSE_URL, 'Compose your piece', 'nav | compose your song', 'nav-compose-your-song', 'topbar__cta');
      var railMarkHtml = trackedLinkHtml(markHref, 'Riffloom<br>Musical<br>Experiences', 'nav | logo', 'nav-logo', 'rail__mark');
      var topbarMarkHtml = trackedLinkHtml(markHref, 'Riffloom<br>Musical<br>Experiences', 'nav | logo', 'nav-logo', 'topbar__mark');

      var rail = document.createElement('aside');
      rail.className = 'rail';
      rail.setAttribute('aria-label', 'Main');
      rail.innerHTML =
        railMarkHtml + '\n' +
        '<nav class="rail__nav">\n    ' + navLinksHtml + '\n  </nav>\n' +
        ctaHtml;

      var topbar = document.createElement('header');
      topbar.className = 'topbar';
      topbar.id = 'topbar';
      topbar.innerHTML =
        '<div class="topbar__row">\n' +
        '  ' + topbarMarkHtml + '\n' +
        '  <button class="topbar__toggle" id="navToggle" type="button" aria-expanded="false" aria-controls="topbarNav" aria-label="Open menu">\n' +
        '    <span></span><span></span><span></span>\n' +
        '  </button>\n' +
        '</div>\n' +
        '<nav class="topbar__nav" id="topbarNav" hidden>\n  ' + navLinksHtml + '\n' +
        '  ' + topbarCtaHtml + '\n' +
        '</nav>';

      document.body.insertBefore(topbar, document.body.firstChild);
      document.body.insertBefore(rail, document.body.firstChild);
    }

    injectSiteFooter();
  })();

  function injectSiteFooter() {
    if (document.querySelector('footer.footer')) return;

    var SITE_URL = 'https://riffloom.com';

    var footerNav = [
      { href: SITE_URL + '/#about', label: 'About' },
      { href: SITE_URL + '/#works', label: 'Featured' },
      { href: SITE_URL + '/#how-it-works', label: 'How It Works' },
      { href: SITE_URL + '/#occasions', label: 'Occasions' },
      { href: SITE_URL + '/#packages', label: 'Packages' },
      { href: SITE_URL + '/#artists', label: 'Artists' },
      { href: SITE_URL + '/#faq', label: 'FAQ' },
    ];

    var footerWork = [
      { id: 'noah-and-amro', title: 'My Love For You Never Ends' },
      { id: 'jack-and-molly', title: 'Wedding Waltz' }
    ];
    var footerLegal = [
      { href: '/policies/terms-of-service', label: 'Terms of Service' },
      { href: '/policies/privacy-policy', label: 'Privacy Policy' },
      { href: '/policies/refund-policy', label: 'Refund Policy' }
    ];

    var footer = document.querySelector('footer') || document.createElement('footer');
    footer.className = 'footer';
    footer.innerHTML =
      '<nav class="footer__col">\n' +
      '  <p class="label">Explore</p>\n  ' +
      footerNav.map(function (l) {
        return trackedLinkHtml(l.href, l.label, 'footer | explore | ' + l.label.toLowerCase(), 'footer-' + slug(l.label));
      }).join('\n  ') +
      '\n</nav>\n' +
      '<nav class="footer__col">\n' +
      '  <p class="label">Work</p>\n' +
      footerWork.map(function (w) {
        return '  ' + trackedLinkHtml(
          SITE_URL + '/pages/example-gift-' + w.id + '?save=false',
          w.title, 'footer | work | ' + w.id, 'footer-work-' + w.id, '',
          ' target="_blank" rel="noopener" data-pause-playbar');
      }).join('\n') + '\n' +
      '</nav>\n' +
      '<div class="footer__col">\n' +
      '  <p class="label">Contact</p>\n' +
      '  <button type="button" class="footer__contact-btn" data-contact-open data-button-name="footer | contact | contact us">Contact us</button>\n' +
      '  <p class="footer__text">Toronto, ON \u00b7 Canada</p>\n' +
      '</div>\n' +
      '<nav class="footer__col">\n' +
      '  <p class="label">Legal</p>\n' +
      footerLegal.map(function (l) {
        return '  ' + trackedLinkHtml(l.href, l.label, 'footer | legal | ' + l.label.toLowerCase(), 'footer-' + slug(l.label));
      }).join('\n') + '\n' +
      '</nav>';
    if (!footer.parentNode) document.body.appendChild(footer);

  }

  var topbar = document.getElementById('topbar');
  var toggle = document.getElementById('navToggle');
  var topbarNav = document.getElementById('topbarNav');
  var menuFadeTimer = null;

  function setMenu(open) {
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    topbar.classList.toggle('is-open', open);
    window.clearTimeout(menuFadeTimer);

    if (open) {
      topbarNav.hidden = false;
      requestAnimationFrame(function () {
        topbarNav.classList.add('is-open');
      });
    } else {
      topbarNav.classList.remove('is-open');
      var fadeMs = reduceMotion ? 0 : 260;
      menuFadeTimer = window.setTimeout(function () {
        topbarNav.hidden = true;
      }, fadeMs);
    }
  }

  if (toggle) {
    setMenu(false);
    toggle.addEventListener('click', function () {
      setMenu(toggle.getAttribute('aria-expanded') !== 'true');
    });

    topbarNav.addEventListener('click', function (event) {
      if (event.target.closest('a')) setMenu(false);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
        setMenu(false);
        toggle.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (toggle.getAttribute('aria-expanded') !== 'true') return;
      if (topbarNav.contains(event.target) || toggle.contains(event.target)) return;
      setMenu(false);
    });
  }

  var navLinks = Array.prototype.slice.call(
    document.querySelectorAll('.rail__nav a, .topbar__nav a')
  ).filter(function (link) {
    return link.getAttribute('href').indexOf('#') === 0 && link.getAttribute('href').length > 1;
  });

  var sections = navLinks
    .map(function (link) { return document.querySelector(link.getAttribute('href')); })
    .filter(Boolean);

  var uniqueSections = sections.filter(function (section, index) {
    return sections.indexOf(section) === index;
  });

  if ('IntersectionObserver' in window && uniqueSections.length) {
    var visible = new Set();

    var spy = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target.id);
        else visible.delete(entry.target.id);
      });

      var current = uniqueSections
        .filter(function (section) { return visible.has(section.id); })
        .map(function (section) { return section.id; })[0];

      if (!current) return;

      navLinks.forEach(function (link) {
        var isCurrent = link.getAttribute('href') === '#' + current;
        link.classList.toggle('is-active', isCurrent);
      });
    }, { rootMargin: '-45% 0px -50% 0px', threshold: 0 });

    uniqueSections.forEach(function (section) { spy.observe(section); });
  }

  var appearing = document.querySelectorAll('[data-appear]');

  if (reduceMotion) {
    appearing.forEach(function (el) { el.classList.add('is-in'); });
  } else {
    requestAnimationFrame(function () {
      appearing.forEach(function (el) { el.classList.add('is-in'); });
    });
  }

  if (!reduceMotion && 'IntersectionObserver' in window) {
    var targets = document.querySelectorAll('.section > .eyebrow, .section > .h2, .section > .lede, .about__body > *');

    targets.forEach(function (el) { el.setAttribute('data-reveal', ''); });

    var revealer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry, index) {
        if (!entry.isIntersecting) return;
        entry.target.style.transitionDelay = (index * 60) + 'ms';
        entry.target.classList.add('is-in');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.15 });

    targets.forEach(function (el) { revealer.observe(el); });
  }

  document.querySelectorAll('.faq').forEach(function (faq) {
    var items = faq.querySelectorAll('.faq__item');
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  });

  function openDetailsTarget(hash, smooth) {
    if (!hash || hash.length < 2) return false;
    var target;
    try { target = document.querySelector(hash); } catch (e) { return false; }
    if (!target) return false;
    var details = target.tagName === 'DETAILS' ? target : target.closest('details');
    if (!details) return false;

    var list = details.closest('.faq');
    if (list) {
      list.querySelectorAll('.faq__item[open]').forEach(function (other) {
        if (other !== details) other.open = false;
      });
    }
    details.open = true;
    target.scrollIntoView({ behavior: smooth && !reduceMotion ? 'smooth' : 'auto', block: 'start' });
    return true;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href^="#"]');
    if (!link) return;
    var hash = link.getAttribute('href');
    if (openDetailsTarget(hash, true)) {
      event.preventDefault();
      try { history.pushState(null, '', hash); } catch (e) {  }
    }
  });

  window.addEventListener('hashchange', function () {
    openDetailsTarget(window.location.hash, true);
  });

  if (window.location.hash) openDetailsTarget(window.location.hash, false);

  (function () {
    var frame = document.getElementById('spotlightFrame');
    var wrap = document.querySelector('.spotlight__frame');
    var loading = document.getElementById('spotlightLoading');
    if (!frame || !wrap) return;

    function sizeSpotlight() {
      var scale = wrap.clientWidth / 1280;
      frame.style.transform = 'scale(' + scale + ')';
      wrap.style.height = Math.round(800 * scale) + 'px';
    }
    window.addEventListener('resize', sizeSpotlight);

    frame.addEventListener('load', function () {
      if (loading) loading.classList.add('is-hidden');
    });
    frame.src = 'https://riffloom.com/pages/example-gift-noah-and-amro?autodemo=true&save=false';
    sizeSpotlight();
  })();

  document.querySelectorAll('[data-pause-playbar]').forEach(function (el) {
    el.addEventListener('click', function () { playbarControl.suspend(); });
  });

  (function () {
    var buttons = document.querySelectorAll('[data-note-play]');
    if (!buttons.length) return;

    var TRACK_URLS = {
      raw: 'https://cdn.shopify.com/s/files/1/0771/2125/7526/files/A0_NOAH_AMRO_RAW_e6650338-9f54-4340-865d-141637a34a31.wav',
      melody: 'https://cdn.shopify.com/s/files/1/0771/2125/7526/files/A0_NOAH_AMRO_MELODY.wav',
      // Jack and Molly (partners page). Paste each recording's link between the quotes; until then the button stays greyed out.
      'raw-jm': '',
      'melody-jm': ''
    };

    var audio = new Audio();
    audio.preload = 'none';

    var activeBtn = null;

    function setPlayingUI(btn, isPlaying) {
      btn.classList.toggle('is-playing', isPlaying);
      btn.setAttribute('aria-pressed', String(isPlaying));
    }

    function stopActive() {
      if (!activeBtn) return;
      audio.pause();
      setPlayingUI(activeBtn, false);
      activeBtn = null;
      playbarControl.resume();
    }

    audio.addEventListener('ended', stopActive);

    buttons.forEach(function (btn) {
      var url = TRACK_URLS[btn.dataset.notePlay];
      if (!url) {
        btn.disabled = true;
        btn.title = 'This recording is not set up yet.';
        return;
      }

      btn.setAttribute('aria-pressed', 'false');
      btn.addEventListener('click', function () {
        var reclicked = btn === activeBtn;
        stopActive();
        if (reclicked) return;

        playbarControl.suspend();
        if (audio.src !== url) audio.src = url;
        else audio.currentTime = 0;

        var attempt = audio.play();
        activeBtn = btn;
        setPlayingUI(btn, true);

        if (attempt && typeof attempt.then === 'function') {
          attempt.catch(function () {
            if (activeBtn === btn) {
              setPlayingUI(btn, false);
              activeBtn = null;
              playbarControl.resume();
            }
          });
        }
      });
    });
  })();

  (function () {
    var holders = document.querySelectorAll('[data-score]');
    if (!holders.length) return;

    var VEXFLOW_URL = 'https://cdn.jsdelivr.net/npm/vexflow@4.2.5/build/cjs/vexflow.js';
    var SVGNS = 'http://www.w3.org/2000/svg';
    var INK = { strokeStyle: '#000', fillStyle: '#000' };
    var H = 190;
    var CROP_TOP = 22;
    var CROP_BOTTOM = 18;
    var TOP = 20;
    var LETTER_GAP = 56;
    var GRACE_GAP = -3;

    function loadVexFlow() {
      if (window.Vex) return Promise.resolve(window.Vex);
      return new Promise(function (resolve, reject) {
        var s = document.createElement('script');
        s.src = VEXFLOW_URL;
        s.async = true;
        s.onload = function () { window.Vex ? resolve(window.Vex) : reject(new Error('VexFlow missing')); };
        s.onerror = function () { reject(new Error('VexFlow failed to load')); };
        document.head.appendChild(s);
      });
    }

    function canvasFor(VF, W, Hc) {
      Hc = Hc || H;
      var el = document.createElement('div');
      var r = new VF.Renderer(el, VF.Renderer.Backends.SVG);
      r.resize(W, Hc);
      var ctx = r.getContext();
      ctx.setFillStyle('#000');
      ctx.setStrokeStyle('#000');
      var svg = el.querySelector('svg');
      svg.setAttribute('viewBox', '0 ' + CROP_TOP + ' ' + W + ' ' + (Hc - CROP_TOP - CROP_BOTTOM));
      svg.removeAttribute('width');
      svg.removeAttribute('height');
      svg.removeAttribute('style');
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
      return { ctx: ctx, svg: svg };
    }

    function centreOf(note) { return note.getAbsoluteX() + note.getGlyphWidth() / 2; }

    function letter(svg, note, text, y) {
      var t = document.createElementNS(SVGNS, 'text');
      t.setAttribute('x', centreOf(note).toFixed(1));
      t.setAttribute('y', y);
      t.setAttribute('text-anchor', 'middle');
      t.setAttribute('class', 'diagram-score__letter');
      t.textContent = text;
      svg.appendChild(t);
    }

    function slur(svg, from, to) {
      var x1 = centreOf(from), x2 = centreOf(to);
      var y = Math.max(from.getYs()[0], to.getYs()[0]) + 9;
      var mx = (x1 + x2) / 2, depth = 7, thick = 1.6;
      var p = document.createElementNS(SVGNS, 'path');
      p.setAttribute('d', 'M' + x1 + ',' + y + ' Q' + mx + ',' + (y + depth + thick) + ' ' + x2 + ',' + y +
                          ' Q' + mx + ',' + (y + depth - thick) + ' ' + x1 + ',' + y + 'Z');
      p.setAttribute('fill', '#000');
      svg.appendChild(p);
    }

    function swapIn(holder, svg) {
      holder.textContent = '';
      holder.appendChild(svg);
      holder.classList.add('is-drawn');
    }

    function drawMelody(VF, holder) {
      var measures = [
        [['c/4','8',0,'N'], ['d/4','8',0,'']],
        [['f/4','h',1,'R'], ['c/4','8',0,'A'], ['d/4','8',0,'O']],
        [['g/4','h',1,'A'], ['c/4','8',0,''],  ['d/4','8',0,'']],
        [['a/4','8',0,''], ['bb/4','8',0,''], ['a/4','8',0,'H'], ['g/4','8',0,''],
         ['f/4','8',0,''], ['d/4','8',0,''],  ['f/4','8',0,'O'], ['g/4','8',0,'']],
        [['d/4','h',1,'M',1]]
      ];
      var beats = [1, 4, 4, 4, 3];
      var pairs = [[0, 0], [1, 1], [2, 1]];
      var widths = measures.map(function (m, i) { return (m.length + 1) * 44 + (i === 4 ? 40 : 0); });

      function build(i, x, w) {
        var stave = new VF.Stave(x, TOP, w);
        stave.setStyle(INK);
        if (i === 0) stave.addClef('treble').addKeySignature('F').addTimeSignature('4/4');
        if (i === measures.length - 1) stave.setEndBarType(VF.Barline.type.SINGLE);
        var notes = measures[i].map(function (spec) {
          var n = new VF.StaveNote({ keys: [spec[0]], duration: spec[1] + (spec[2] ? 'd' : '') });
          n.setLedgerLineStyle(INK);
          n.setStave(stave);
          if (spec[2]) VF.Dot.buildAndAttach([n], { all: true });
          if (spec[4]) {
            var g = new VF.GraceNote({ keys: ['c/4'], duration: '8', slash: true });
            g.setStyle(INK);
            g.setLedgerLineStyle(INK);
            var group = new VF.GraceNoteGroup([g], false).beamNotes();
            n.addModifier(group, 0);
            n.graceGroup = group;
            n.graceNote = g;
          }
          return n;
        });
        var voice = new VF.Voice({ num_beats: beats[i], beat_value: 4 })
          .setMode(VF.Voice.Mode.SOFT).addTickables(notes);
        var beams = VF.Beam.generateBeams(notes, { groups: [new VF.Fraction(2, 4)] });
        var avail = w - (stave.getNoteStartX() - x) - 18;
        new VF.Formatter({ softmaxFactor: 3 }).joinVoices([voice]).format([voice], avail);
        return { stave: stave, notes: notes, voice: voice, beams: beams };
      }

      var ref = build(1, 0, widths[1]);
      var gap = ref.notes[2].getAbsoluteX() - ref.notes[1].getAbsoluteX();
      var tail = widths[1] - ref.notes[2].getAbsoluteX();
      var probe = build(0, 10, 400);
      widths[0] = (probe.notes[0].getAbsoluteX() - 10) + gap + tail;

      var W = 20 + widths.reduce(function (a, b) { return a + b; }, 0);
      var c = canvasFor(VF, W);

      var x = 10;
      var built = measures.map(function (m, i) { var b = build(i, x, widths[i]); x += widths[i]; return b; });

      built.forEach(function (b) {
        b.notes.forEach(function (n) {
          if (!n.graceGroup) return;
          var m = n.getTickContext().getMetrics();
          n.graceGroup.setSpacingFromNextModifier(m.modLeftPx + m.modRightPx - n.graceGroup.getWidth() - GRACE_GAP);
        });
      });

      pairs.forEach(function (p) {
        var cNote = built[p[0]].notes[p[1]], dNote = built[p[0]].notes[p[1] + 1];
        dNote.getTickContext().setX(cNote.getTickContext().getX() + gap);
      });

      var letters = [];
      built.forEach(function (b, i) {
        b.stave.setContext(c.ctx).draw();
        b.voice.draw(c.ctx, b.stave);
        b.beams.forEach(function (beam) { beam.setContext(c.ctx).draw(); });
        measures[i].forEach(function (spec, j) { if (spec[3]) letters.push([b.notes[j], spec[3]]); });
      });
      built.forEach(function (b) {
        b.notes.forEach(function (n) { if (n.graceNote) slur(c.svg, n.graceNote, n); });
      });

      var y = built[0].stave.getYForLine(4) + LETTER_GAP;
      letters.forEach(function (l) { letter(c.svg, l[0], l[1], y); });
      swapIn(holder, c.svg);
      return { W: W, firstX: centreOf(built[0].notes[0]) };
    }

    function drawRaw(VF, holder, W, firstX) {
      var c = canvasFor(VF, W);
      var stave = new VF.Stave(10, TOP, W - 20);
      stave.setStyle(INK);
      stave.addClef('treble').setEndBarType(VF.Barline.type.SINGLE);

      var data = [['c/4','N'], ['d/4','O'], ['c/4','A'], ['g/4','H'], ['c/4','A'], ['c/4','M'], ['f/4','R'], ['d/4','O']];
      var notes = data.map(function (d) {
        var n = new VF.StaveNote({ keys: [d[0]], duration: 'w' });
        n.setLedgerLineStyle(INK);
        n.setStave(stave);
        return n;
      });
      var voice = new VF.Voice({ num_beats: 32, beat_value: 4 }).addTickables(notes);
      function fmt() {
        var avail = W - 20 - (stave.getNoteStartX() - 10) - 20;
        new VF.Formatter().joinVoices([voice]).format([voice], avail * 8 / 7.4);
      }
      fmt();
      stave.setNoteStartX(stave.getNoteStartX() + (firstX - centreOf(notes[0])));
      fmt();
      stave.setContext(c.ctx).draw();
      voice.draw(c.ctx, stave);

      var y = stave.getYForLine(4) + LETTER_GAP;
      notes.forEach(function (n, i) { letter(c.svg, n, data[i][1], y); });
      swapIn(holder, c.svg);
    }

    // Jack and Molly: Bb major, 3/4. Letters J A C K M O L L Y become the notes A C D Bb C D Bb Bb C.
    // Used by the partners page with data-piece="jack-molly" on the two score holders.
    var JM_H = 205;
    var JM_LETTER_GAP = 70;
    var JM_LETTER_SIZE = '17px';

    function drawMelodyJM(VF, holder) {
      var measures = [
        [['d/5','q',1,'C'], ['c/5','8',0,'A'], ['bb/4','q',0,'K']],
        [['c/5','q',1,'M'], ['bb/4','8',0,'L'], ['a/4','q',0,'J']],
        [['bb/4','h',1,'L']],
        [['bb/4','q',0,''], ['c/5','q',0,'Y'], ['d/5','q',0,'O']]
      ];
      var widths = [236, 200, 128, 196];
      var W = 20 + widths.reduce(function (a, b) { return a + b; }, 0);
      var c = canvasFor(VF, W, JM_H);
      var x = 10, built = [];
      measures.forEach(function (m, i) {
        var stave = new VF.Stave(x, TOP, widths[i]);
        stave.setStyle(INK);
        if (i === 0) stave.addClef('treble').addKeySignature('Bb').addTimeSignature('3/4');
        if (i === measures.length - 1) stave.setEndBarType(VF.Barline.type.SINGLE);
        var notes = m.map(function (spec) {
          var n = new VF.StaveNote({ keys: [spec[0]], duration: spec[1] + (spec[2] ? 'd' : ''), stem_direction: VF.Stem.DOWN });
          n.setLedgerLineStyle(INK);
          n.setStave(stave);
          if (spec[2]) VF.Dot.buildAndAttach([n], { all: true });
          return n;
        });
        var voice = new VF.Voice({ num_beats: 3, beat_value: 4 }).setMode(VF.Voice.Mode.SOFT).addTickables(notes);
        var avail = widths[i] - (stave.getNoteStartX() - x) - 18;
        new VF.Formatter({ softmaxFactor: 6 }).joinVoices([voice]).format([voice], avail);
        built.push({ stave: stave, notes: notes, voice: voice });
        x += widths[i];
      });
      var letters = [];
      built.forEach(function (b, i) {
        b.stave.setContext(c.ctx).draw();
        b.voice.draw(c.ctx, b.stave);
        measures[i].forEach(function (spec, j) { if (spec[3]) letters.push([b.notes[j], spec[3]]); });
      });
      // the dotted half note in bar 3 is tied over the barline to the quarter note in bar 4
      new VF.StaveTie({ first_note: built[2].notes[0], last_note: built[3].notes[0], first_indices: [0], last_indices: [0] })
        .setContext(c.ctx).draw();
      var y = built[0].stave.getYForLine(4) + JM_LETTER_GAP;
      letters.forEach(function (l) { letter(c.svg, l[0], l[1], y); });
      Array.prototype.forEach.call(c.svg.querySelectorAll('.diagram-score__letter'), function (t) { t.style.fontSize = JM_LETTER_SIZE; });
      swapIn(holder, c.svg);
      return { W: W, firstX: centreOf(built[0].notes[0]) };
    }

    function drawRawJM(VF, holder, W, firstX) {
      var c = canvasFor(VF, W, JM_H);
      var stave = new VF.Stave(10, TOP, W - 20);
      stave.setStyle(INK);
      stave.addClef('treble').addKeySignature('Bb').setEndBarType(VF.Barline.type.SINGLE);
      var data = [['a/4','J'], ['c/4','A'], ['d/4','C'], ['bb/4','K'], ['c/4','M'], ['d/4','O'], ['bb/4','L'], ['bb/4','L'], ['c/4','Y']];
      var notes = data.map(function (d) {
        var n = new VF.StaveNote({ keys: [d[0]], duration: 'w' });
        n.setLedgerLineStyle(INK);
        n.setStave(stave);
        return n;
      });
      var voice = new VF.Voice({ num_beats: data.length * 4, beat_value: 4 }).addTickables(notes);
      function fmt() {
        var avail = W - 20 - (stave.getNoteStartX() - 10) - 20;
        new VF.Formatter().joinVoices([voice]).format([voice], avail * data.length / (data.length - 0.6));
      }
      fmt();
      stave.setNoteStartX(stave.getNoteStartX() + (firstX - centreOf(notes[0])));
      fmt();
      stave.setContext(c.ctx).draw();
      voice.draw(c.ctx, stave);
      var y = stave.getYForLine(4) + JM_LETTER_GAP;
      notes.forEach(function (n, i) { letter(c.svg, n, data[i][1], y); });
      Array.prototype.forEach.call(c.svg.querySelectorAll('.diagram-score__letter'), function (t) { t.style.fontSize = JM_LETTER_SIZE; });
      swapIn(holder, c.svg);
    }

    function drawAll() {
      loadVexFlow().then(function (Vex) {
        var VF = Vex.Flow;
        var raw = document.querySelector('[data-score="raw"]');
        var melody = document.querySelector('[data-score="melody"]');
        var jm = (melody && melody.dataset.piece === 'jack-molly') || (raw && raw.dataset.piece === 'jack-molly');
        var size = { W: 1067, firstX: 112 };
        try { if (melody) size = jm ? drawMelodyJM(VF, melody) : drawMelody(VF, melody); }
        catch (e) { if (window.console) console.warn('[Riffloom] melody score not drawn:', e); }
        try { if (raw) (jm ? drawRawJM : drawRaw)(VF, raw, size.W, size.firstX); }
        catch (e) { if (window.console) console.warn('[Riffloom] raw score not drawn:', e); }
      }).catch(function (err) {
        if (window.console) console.warn('[Riffloom] notation not drawn:', err && err.message || err);
      });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries.some(function (e) { return e.isIntersecting; })) return;
        io.disconnect();
        drawAll();
      }, { rootMargin: '600px 0px' });
      holders.forEach(function (h) { io.observe(h); });
    } else {
      drawAll();
    }
  })();

  (function () {
    var PLAYBAR_TRACKS = [
      { title: 'My Love For You Never Ends', names: 'Noah and Amro', occasion: 'Anniversary', src: 'https://cdn.shopify.com/s/files/1/0771/2125/7526/files/A1_NOAH_AMRO_FULL_RECORDING.m4a?v=1789686185' },
      { title: 'Wedding Waltz', names: 'Jack and Molly', occasion: 'Wedding', src: 'https://cdn.shopify.com/s/files/1/0771/2125/7526/files/A3_JACK_AND_MOLLY_FULL_RECORDING.m4a?v=1789686308' },
      { title: 'Apple of My Eye', names: 'Justin and Katy', occasion: 'Bonus track', src: 'https://cdn.shopify.com/s/files/1/0771/2125/7526/files/A4_JUSTIN_KATY_FULL_RECORDING.m4a?v=1789686344' }
    ];

    var bar = document.getElementById('playbar');
    var audio = document.getElementById('playbarAudio');
    if (!bar || !audio) return;

    if (bar.parentElement !== document.body) {
      document.body.appendChild(bar);
    }

    // A page can choose which pieces its playbar plays, and in what order, with
    // data-tracks="Jack and Molly, Noah and Amro, Justin and Katy" on #playbar (names as written in
    // PLAYBAR_TRACKS above). Pages without it play every piece, as before.
    var wanted = (bar.getAttribute('data-tracks') || '').split(',')
      .map(function (n) { return n.trim().toLowerCase(); }).filter(Boolean);
    var pool = PLAYBAR_TRACKS;
    if (wanted.length) {
      pool = wanted.map(function (name) {
        return PLAYBAR_TRACKS.filter(function (t) { return t && String(t.names || '').toLowerCase() === name; })[0];
      }).filter(Boolean);
    }
    var tracks = pool.filter(function (t) {
      return t && typeof t.src === 'string' && t.src.trim() !== '';
    });
    if (!tracks.length) return;

    var toggleBtn = document.getElementById('playbarToggle');
    var prevBtn = document.getElementById('playbarPrev');
    var nextBtn = document.getElementById('playbarNext');
    var titleEl = document.getElementById('playbarTitle');
    var occasionEl = document.getElementById('playbarOccasion');
    var seek = document.getElementById('playbarSeek');
    var elapsedEl = document.getElementById('playbarElapsed');
    var durationEl = document.getElementById('playbarDuration');

    var index = 0;
    var scrubbing = false;
    var suspended = false;
    var resumeAfter = false;
    var failures = 0;
    var retries = 0;
    var wantPlay = false;
    var unavailable = false;

    function formatTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '0:00';
      var total = Math.floor(seconds);
      var mins = Math.floor(total / 60);
      var secs = total % 60;
      return mins + ':' + (secs < 10 ? '0' : '') + secs;
    }

    function paintProgress(fraction) {
      seek.style.setProperty('--playbar-progress', (fraction * 100).toFixed(2) + '%');
    }

    function setPlayingClass(isPlaying) {
      bar.classList.toggle('is-playing', isPlaying);
      toggleBtn.setAttribute('aria-label', isPlaying ? 'Pause' : 'Play');
    }

    function trackLabel(track) {
      return [
        track.names || '',
        track.occasion || ''
      ].filter(Boolean).join(' \u00b7 ');
    }

    function showLoading(on) {
      if (unavailable) return;
      bar.classList.toggle('is-loading', on);
      occasionEl.textContent = on ? 'Loading\u2026' : trackLabel(tracks[index]);
    }

    function saveDataOn() {
      var c = navigator.connection;
      return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
    }

    function load(nextIndex, autoplay) {
      index = (nextIndex + tracks.length) % tracks.length;
      var track = tracks[index];
      retries = 0;
      unavailable = false;

      titleEl.textContent = track.title;
      occasionEl.textContent = trackLabel(track);
      elapsedEl.textContent = '0:00';
      durationEl.textContent = '--:--';
      seek.value = 0;
      paintProgress(0);
      bar.classList.remove('is-loading');

      // Ask for the recording's length straight away, so it never sits at 0:00 until someone presses play
      // (the markup says preload="none"). Once the length is known, the whole recording is buffered (see loadedmetadata).
      audio.preload = 'metadata';
      audio.src = track.src;
      audio.load();

      wantPlay = !!autoplay;
      if (autoplay) start();
      else setPlayingClass(false);
    }

    function start() {
      wantPlay = true;
      if (audio.readyState < 3) showLoading(true);
      var attempt = audio.play();
      if (attempt && typeof attempt.then === 'function') {
        attempt.then(function () {
          failures = 0;
          setPlayingClass(true);
        }).catch(function (err) {
          // AbortError means a newer load() interrupted this play(); that load reports its own result.
          if (err && err.name === 'AbortError') return;
          wantPlay = false;
          showLoading(false);
          setPlayingClass(false);
        });
      } else {
        setPlayingClass(true);
      }
    }

    function pause() {
      wantPlay = false;
      audio.pause();
      showLoading(false);
      setPlayingClass(false);
    }

    toggleBtn.addEventListener('click', function () {
      if (audio.paused) start();
      else pause();
    });

    prevBtn.addEventListener('click', function () {
      if (audio.currentTime > 3) {
        audio.currentTime = 0;
        return;
      }
      load(index - 1, !audio.paused);
    });

    nextBtn.addEventListener('click', function () {
      load(index + 1, !audio.paused);
    });

    if (tracks.length < 2) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
    }

    audio.addEventListener('loadedmetadata', function () {
      durationEl.textContent = isFinite(audio.duration) && audio.duration ? formatTime(audio.duration) : '--:--';
      // The length is known, so buffer the recording now and play starts straight away (skipped on data saver / 2G).
      if (!saveDataOn()) audio.preload = 'auto';
    });

    audio.addEventListener('durationchange', function () {
      if (isFinite(audio.duration) && audio.duration) durationEl.textContent = formatTime(audio.duration);
    });

    audio.addEventListener('canplay', function () { showLoading(false); });
    audio.addEventListener('playing', function () { showLoading(false); });
    audio.addEventListener('waiting', function () { if (wantPlay && !audio.paused) showLoading(true); });

    audio.addEventListener('timeupdate', function () {
      if (scrubbing || !isFinite(audio.duration) || !audio.duration) return;
      var fraction = audio.currentTime / audio.duration;
      seek.value = String(Math.round(fraction * 1000));
      paintProgress(fraction);
      elapsedEl.textContent = formatTime(audio.currentTime);
    });

    audio.addEventListener('ended', function () {
      load(index + 1, true);
    });

    audio.addEventListener('error', function () {
      if (!audio.src) return;
      // A dropped connection or a busy CDN is common. Try the same recording again (twice) before skipping it.
      if (retries < 2) {
        retries += 1;
        var failedSrc = audio.src;
        var resumeAfterRetry = wantPlay;
        window.setTimeout(function () {
          if (audio.src !== failedSrc) return;
          audio.load();
          if (resumeAfterRetry) start();
        }, 700 * retries);
        return;
      }
      retries = 0;
      failures += 1;
      if (failures >= tracks.length) {
        wantPlay = false;
        unavailable = true;
        bar.classList.remove('is-loading');
        setPlayingClass(false);
        titleEl.textContent = 'Recording unavailable';
        occasionEl.textContent = '';
        return;
      }
      load(index + 1, wantPlay);
    });

    seek.addEventListener('input', function () {
      scrubbing = true;
      var fraction = Number(seek.value) / 1000;
      paintProgress(fraction);
      if (isFinite(audio.duration) && audio.duration) {
        elapsedEl.textContent = formatTime(fraction * audio.duration);
      }
    });

    seek.addEventListener('change', function () {
      scrubbing = false;
      if (!isFinite(audio.duration) || !audio.duration) return;
      audio.currentTime = (Number(seek.value) / 1000) * audio.duration;
    });

    audio.addEventListener('play', function () { setPlayingClass(true); });
    audio.addEventListener('pause', function () { wantPlay = false; setPlayingClass(false); });

    playbarControl.suspend = function () {
      if (suspended) return;
      suspended = true;
      resumeAfter = !audio.paused;
      if (resumeAfter) pause();
    };

    playbarControl.resume = function () {
      if (!suspended) return;
      suspended = false;
      if (resumeAfter) start();
      resumeAfter = false;
    };

    load(0, false);
    bar.hidden = false;
    document.body.classList.add('has-playbar');
  })();

  (function () {
    var modal = null;
    var panel = null;
    var form = null;
    var fields = null;
    var errorBanner = null;
    var successMessage = null;
    var submitBtn = null;
    var submitLabel = '';
    var sending = false;
    var lastOpener = null;
    var formWired = false;
    var anotherBtn = null;

    function setBackgroundInert(isInert) {
      ['.rail', '.topbar', '#top', '.playbar'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el) return;
        if (isInert) el.setAttribute('inert', ''); else el.removeAttribute('inert');
      });
    }

    function setSending(isSending) {
      sending = isSending;
      if (!submitBtn) return;
      submitBtn.disabled = isSending;
      submitBtn.textContent = isSending ? 'Sending…' : submitLabel;
    }

    function showError() {
      if (errorBanner) errorBanner.hidden = false;
    }

    function showSuccess() {
      if (fields) fields.hidden = true;
      if (errorBanner) errorBanner.hidden = true;
      if (successMessage) successMessage.hidden = false;
    }

    function resetToBlankForm() {
      if (successMessage) successMessage.hidden = true;
      if (errorBanner) errorBanner.hidden = true;
      if (fields) fields.hidden = false;
      if (form) form.reset();
    }

    function wireForm() {
      if (formWired || !form) return;
      formWired = true;

      submitBtn = form.querySelector('.contact-form__submit');
      submitLabel = submitBtn ? submitBtn.textContent : '';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (sending) return;

        var gotcha = form.querySelector('#contactHp');
        if (gotcha && gotcha.value.trim() !== '') {
          showSuccess();
          return;
        }

        if (errorBanner) errorBanner.hidden = true;
        setSending(true);

        fetch(form.action, {
          method: form.method || 'post',
          body: new FormData(form),
          credentials: 'same-origin'
        }).then(function (res) {
          var url = (res && res.url) || '';
          // Shopify's spam check: send the visitor to the challenge page to finish sending.
          if (/\/challenge(\?|$)/.test(url)) { window.location.assign(url); return; }
          // Shopify redirects to ?contact_posted=true only when the message was accepted.
          // Anything else (validation errors, server errors) is a failure.
          if (!/[?&]contact_posted=true(&|$)/.test(url)) throw new Error('not posted');
          setSending(false);
          showSuccess();
        }).catch(function () {
          setSending(false);
          showError();
        });
      });
    }

    function findModal() {
      if (modal) return modal;

      var copies = document.querySelectorAll('#contactModal');
      for (var i = copies.length - 1; i > 0; i--) {
        if (copies[i].parentNode) copies[i].parentNode.removeChild(copies[i]);
      }

      modal = copies[0] || null;
      if (!modal) return null;

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      panel = modal.querySelector('.contact-modal__panel');
      form = modal.querySelector('#contactModalForm');
      fields = modal.querySelector('#contactFormFields');
      errorBanner = modal.querySelector('#contactFormError');
      successMessage = modal.querySelector('#contactFormSuccess');
      anotherBtn = modal.querySelector('#contactFormAnother');

      modal.querySelectorAll('[data-contact-close]').forEach(function (el) {
        el.addEventListener('click', closeContact);
      });
      if (anotherBtn) {
        anotherBtn.addEventListener('click', function () {
          resetToBlankForm();
          var first = form && form.querySelector('input, textarea');
          if (first && first.focus) first.focus();
        });
      }
      wireForm();

      return modal;
    }

    // Alternate wording for the contact lightbox. A button asks for one with data-contact-variant="partner";
    // every other button gets the original wording back.
    var CONTACT_VARIANTS = {
      partner: {
        title: 'Become a partner',
        lede: 'Tell us a little about your business and the couples you work with, and we\u2019ll get you set up as a referral partner.',
        submit: 'Become a partner',
        success: 'Thanks! We\u2019ve got your details and will be in touch soon to get you set up as a partner.',
        placeholder: 'Your business, and the kind of couples you work with',
        enquiry: 'Partner application'
      }
    };

    function applyContactVariant(name) {
      var v = CONTACT_VARIANTS[name] || null;
      function swap(el, text, isPlaceholder) {
        if (!el) return;
        if (isPlaceholder) {
          if (el.getAttribute('data-default-placeholder') === null) el.setAttribute('data-default-placeholder', el.getAttribute('placeholder') || '');
          if (v && text) el.setAttribute('placeholder', text);
          else el.setAttribute('placeholder', el.getAttribute('data-default-placeholder'));
          return;
        }
        if (el.__defaultHtml === undefined) el.__defaultHtml = el.innerHTML;
        if (v && text) el.textContent = text; else el.innerHTML = el.__defaultHtml;
      }
      swap(modal.querySelector('.contact-modal__title'), v && v.title);
      swap(modal.querySelector('.contact-modal__lede'), v && v.lede);
      swap(modal.querySelector('.contact-form__success-text'), v && v.success);
      swap(form && form.querySelector('textarea'), v && v.placeholder, true);
      if (submitBtn) {
        if (submitBtn.__defaultLabel === undefined) submitBtn.__defaultLabel = submitLabel || submitBtn.textContent;
        submitLabel = (v && v.submit) || submitBtn.__defaultLabel;
        if (!sending) submitBtn.textContent = submitLabel;
      }
      // Tags the message so partner applications can be told apart from ordinary enquiries in the email.
      if (form) {
        var tag = form.querySelector('input[data-contact-enquiry]');
        if (tag) tag.parentNode.removeChild(tag);
        if (v && v.enquiry) {
          tag = document.createElement('input');
          tag.type = 'hidden';
          tag.name = 'contact[Enquiry type]';
          tag.value = v.enquiry;
          tag.setAttribute('data-contact-enquiry', '');
          form.appendChild(tag);
        }
      }
    }

    function openContact(opener, preserveState) {
      if (!findModal()) return;
      applyContactVariant(opener && opener.getAttribute ? opener.getAttribute('data-contact-variant') : null);

      lastOpener = opener || null;
      playbarControl.suspend();
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      setBackgroundInert(true);

      if (!preserveState && successMessage && !successMessage.hidden) resetToBlankForm();

      var scope = (fields && !fields.hidden) ? fields : (successMessage || modal);
      var first = scope.querySelector('input:not([type="hidden"]), textarea, button:not([data-contact-close])');
      if (first && first.focus) first.focus();
      else if (panel && panel.focus) panel.focus();
    }

    function closeContact() {
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      setBackgroundInert(false);
      playbarControl.resume();
      if (lastOpener && lastOpener.focus) lastOpener.focus();
      lastOpener = null;
    }

    // One listener for every [data-contact-open] on the page, including ones added later (navbar, footer).
    document.addEventListener('click', function (event) {
      var el = event.target && event.target.closest ? event.target.closest('[data-contact-open]') : null;
      if (!el) return;
      event.preventDefault();
      openContact(el);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal && !modal.hidden) closeContact();
    });

    if (/[?&]contact_posted=true(&|$)/.test(location.search) && findModal()) {
      openContact(null, true);
    }
  })();
})();

(function () {
  'use strict';

  if (!document.getElementById('wizForm')) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var PACKAGES = {
    sonatina: {
      label: 'Sonatina', base: null,
      summary: 'A song as a gift: a 2-minute original piano song, delivered on a private reveal page for them to open.',
      items: [
        { id: 'audio',     label: 'A 2-minute audio recording of your piece', core: true },
        { id: 'sheet',     label: 'A digital copy of the sheet music, ready to print and frame', core: true },
        { id: 'letter',    label: "A letter from your composer, explaining how your story shaped the piece", core: true },
        { id: 'reveal',    label: 'A private reveal page', note: 'Emailed to you as soon as your piece is complete', core: true },
        { id: 'revisions', label: 'One round of revisions', core: true },
        { id: 'exclusive', label: 'Exclusively yours, for personal use', core: true },
        { id: 'rush',      label: 'Rush delivery', note: 'One week instead of three', price: null, def: false },
        { id: 'extraMinute', label: 'A third minute of music', note: 'One extra minute of original music', price: null, def: false },
        { id: 'slideshow',   label: 'A video slideshow of your photographs', note: 'Accompanies the audio recording of your piece', price: null, def: false },
        { id: 'countdown',   label: 'A countdown page for the recipient', note: 'Sent within 24 hours of your order', price: null, def: false }
      ]
    },
    sonata: {
      label: 'Sonata', base: 1000,
      summary: 'Music for your event or ceremony: written around each of its moments, and shaped with your composer on a call.',
      items: [
        { id: 'audio',     label: 'An audio recording of your piece, longer than 3 minutes', note: 'Written to fit what happens at your event and when', core: true },
        { id: 'sheet',     label: 'A digital copy of the sheet music, ready to print and frame', core: true },
        { id: 'letter',    label: "A letter from your composer, explaining how your story shaped the piece", core: true },
        { id: 'reveal',    label: 'A private reveal page', note: 'Emailed to you as soon as your piece is complete', core: true },
        { id: 'revisions', label: 'Two rounds of revisions', core: true },
        { id: 'exclusive', label: 'Exclusively yours, for personal use', core: true },
        { id: 'slideshow', label: 'A video slideshow of your photographs', note: 'Accompanies the audio recording of your piece', price: 0, def: false }
      ]
    }
  };
  var PKG_ORDER = ['sonatina', 'sonata'];

  function hasPrice(n) { return typeof n === 'number' && isFinite(n); }
  function amt(n) { return hasPrice(n) ? n.toLocaleString('en-CA') : 'X'; }
  var CATALOG = window.RIFFLOOM_CATALOG || {};
  var CATALOG_ERRORS = [];
  function catalogEntry(key) {
    var e = CATALOG[key];
    if (!e || !e.id || typeof e.price !== 'number' || !isFinite(e.price)) {
      CATALOG_ERRORS.push(key);
      return null;
    }
    return e;
  }
  (function applyCatalogPrices() {
    var main = catalogEntry('sonatina');
    if (main) PACKAGES.sonatina.base = main.price / 100;
    PACKAGES.sonatina.items.forEach(function (item) {
      if (item.core) return;
      var e = catalogEntry(item.id);
      if (e) item.price = e.price / 100;
    });
    if (CATALOG_ERRORS.length) {
      console.error('[Riffloom] Missing or invalid Shopify product data for: ' + CATALOG_ERRORS.join(', ') +
        '. Check the product handles at the top of page.start.liquid. Those prices show as "$X" and checkout is disabled until this is fixed.');
    }
  })();

  var STORAGE_KEY = 'riffloomStartFlow_v3';

  var STORAGE_MAX_DAYS = 30;

  function readStoredState() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var entry = JSON.parse(raw);
      if (!entry || typeof entry.savedAt !== 'number' || !entry.state ||
          Date.now() - entry.savedAt > STORAGE_MAX_DAYS * 86400000) {
        window.localStorage.removeItem(STORAGE_KEY);
        return null;
      }
      return entry.state;
    } catch (err) { return null; }
  }
  function writeStoredState(obj) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify({ savedAt: Date.now(), state: obj }));
      return true;
    } catch (err) { return false; }
  }
  function clearStoredState() {
    try { window.localStorage.removeItem(STORAGE_KEY); } catch (err) {  }
  }

  function getCookie(name) {
    var target = name + '=';
    var parts = document.cookie.split('; ');
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].indexOf(target) === 0) return decodeURIComponent(parts[i].slice(target.length));
    }
    return null;
  }
  function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
  }
  function readLegacyCookieState() {
    var count = parseInt(getCookie(STORAGE_KEY + '_count') || '0', 10);
    if (!count) return null;
    var parts = [];
    for (var i = 0; i < count; i++) {
      var chunk = getCookie(STORAGE_KEY + '_' + i);
      if (chunk === null) return null;
      parts.push(chunk);
    }
    try { return JSON.parse(parts.join('')); } catch (err) { return null; }
  }
  function deleteLegacyCookies() {
    var count = parseInt(getCookie(STORAGE_KEY + '_count') || getCookie(STORAGE_KEY + '_count_prev') || '0', 10);
    for (var i = 0; i < count; i++) deleteCookie(STORAGE_KEY + '_' + i);
    deleteCookie(STORAGE_KEY + '_count');
    deleteCookie(STORAGE_KEY + '_count_prev');
  }

  var state = {
    forWhom: null, relationship: '', relationshipOther: '', occasion: null, occasionOther: '',
    recipientNames: [''], giverName: '', occasionDate: '', noDateYet: false,
    story: '', giftNote: '', eventDetails: '',
    referralSource: '', referralSourceOther: '',
    contactMethod: 'email', contactValue: '', contactPhone: '',
    coverMessage: '', coverMessageEdited: false,
    giftNoteEdited: false,
    countdownMessage: '',
    countdownMessageEdited: false,
    soundRequest: '',
    pkg: null,
    pkgTouched: false,
    items: {},
    callType: 'phone',
    meetSlots: [],
    promoCode: '',
    agreeTerms: false,
    keepPrivate: false,
    handedOff: false
  };
  PKG_ORDER.forEach(function (pkgId) {
    state.items[pkgId] = {};
    PACKAGES[pkgId].items.forEach(function (item) {
      state.items[pkgId][item.id] = item.core ? true : !!item.def;
    });
  });

  function loadState() {
    var saved = readStoredState();
    if (!saved) {
      var legacy = readLegacyCookieState();
      if (legacy) {
        saved = legacy;
        if (writeStoredState(legacy)) deleteLegacyCookies();
      }
    }
    if (!saved) return;
    try {
      for (var k in saved) { if (k in state) state[k] = saved[k]; }
    } catch (err) {  }
    if (!PACKAGES[state.pkg]) { state.pkg = null; state.pkgTouched = false; }
  }

  var saveTimer = null;
  var cartPush = { timer: null, running: false, again: false, current: null };
  var submitInFlight = false;
  function saveState() {
    window.clearTimeout(saveTimer);
    saveTimer = window.setTimeout(function () {
      writeStoredState(state);
      flashSaveNote();
      scheduleCartPush();
    }, 400);
  }

  var saveNote = document.getElementById('saveNote');
  var saveNoteTimer = null;
  function flashSaveNote() {
    if (!state.forWhom) return;
    saveNote.classList.remove('is-idle');
    window.clearTimeout(saveNoteTimer);
    saveNoteTimer = window.setTimeout(function () { saveNote.classList.add('is-idle'); }, 1800);
  }

  loadState();

  (function () {
    var params = new URLSearchParams(window.location.search);
    var requested = params.get('package');
    if (requested && PACKAGES[requested]) {
      state.pkg = requested;
      state.pkgTouched = true;
      writeStoredState(state);
      try {
        params.delete('package');
        var qs = params.toString();
        window.history.replaceState(window.history.state, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
      } catch (err) {  }
    }
  })();

  var ALL_STEPS = ['intro', 'package', 'details', 'page-content', 'meet', 'review', 'confirmation'];
  var STEP_LABELS = {
    intro: 'The basics', package: 'The package', details: 'The details',
    'page-content': 'Their page & preview',
    meet: 'Meet your composer',
    review: 'Review & submit',
    confirmation: 'Confirmation'
  };
  var currentIndex = 0;

  function isMemorialPath() {
    return state.occasion === 'Memorial' ||
      (state.occasion === 'Other' && /funeral/i.test(state.occasionOther || ''));
  }

  function visibleSteps() {
    if (isMemorialPath()) {
      return ['intro', 'meet', 'confirmation'];
    }
    if (state.pkg === 'sonata') {
      return ALL_STEPS.filter(function (s) { return s !== 'page-content'; });
    }
    return ALL_STEPS.filter(function (s) { return s !== 'meet' && s !== 'review' && s !== 'confirmation'; });
  }

  var progressEl = document.getElementById('wizProgress');
  var stepLabelEl = document.getElementById('wizStepLabel');
  var backBtn = document.getElementById('backBtn');
  var nextBtn = document.getElementById('nextBtn');
  var footerPkgValue = document.getElementById('footerPkgValue');
  var footerPriceValue = document.getElementById('footerPriceValue');
  var footerStats = document.getElementById('footerStats');
  var viewBreakdownBtn = document.getElementById('viewBreakdownBtn');
  var sections = {};
  document.querySelectorAll('.wiz-step').forEach(function (s) { sections[s.dataset.step] = s; });

  function renderProgress() {
    var steps = visibleSteps();
    var curId = steps[currentIndex];
    progressEl.innerHTML = '';
    steps.forEach(function (id, i) {
      var seg = document.createElement('div');
      var isDone = curId === 'confirmation' || i < currentIndex;
      seg.className = 'wiz-progress__seg' + (isDone ? ' is-done' : i === currentIndex ? ' is-current' : '');
      progressEl.appendChild(seg);
    });
    stepLabelEl.textContent = 'Step ' + (currentIndex + 1) + ' of ' + steps.length + ' · ' + STEP_LABELS[curId];
  }

  function renderFooter() {
    var steps = visibleSteps();
    var curId = steps[currentIndex];

    if (curId === 'confirmation') {
      backBtn.style.visibility = 'hidden';
      nextBtn.style.display = 'none';
      footerStats.style.display = 'none';
      viewBreakdownBtn.hidden = true;
      return;
    }
    backBtn.style.visibility = currentIndex === 0 ? 'hidden' : 'visible';

    nextBtn.style.display = '';
    nextBtn.removeAttribute('data-button-name');
    if (curId === 'review') {
      nextBtn.textContent = 'Submit';
      nextBtn.setAttribute('data-button-name', 'checkout | sonata | submit');
    } else if (curId === 'page-content' && state.pkg !== 'sonata') {
      nextBtn.textContent = 'Go to cart';
    } else if (curId === 'meet' && isMemorialPath()) {
      nextBtn.textContent = 'Request a call';
      nextBtn.setAttribute('data-button-name', 'checkout | memorial | submit');
    } else {
      nextBtn.textContent = 'Continue';
    }

    if (isMemorialPath() && (curId === 'details' || curId === 'meet')) {
      footerStats.style.display = 'none';
      viewBreakdownBtn.hidden = true;
      return;
    }

    footerStats.style.display = '';
    footerPkgValue.textContent = state.pkgTouched ? PACKAGES[state.pkg].label : 'TBD';
    if (!state.pkgTouched) {
      footerPriceValue.textContent = 'TBD';
    } else if (state.pkg === 'sonata') {
      footerPriceValue.textContent = 'From $' + amt(PACKAGES.sonata.base) + ' CAD';
    } else {
      footerPriceValue.textContent = '$' + amt(packageTotal()) + ' CAD';
    }

    viewBreakdownBtn.hidden = !state.pkgTouched;
  }

  function goToStep(index) {
    if (consultationSending) return;
    var steps = visibleSteps();
    if (index < 0 || index >= steps.length) return;
    Object.keys(sections).forEach(function (id) { sections[id].classList.remove('is-active'); });
    currentIndex = index;
    sections[steps[currentIndex]].classList.add('is-active');
    renderProgress();
    renderFooter();
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
    if (steps[currentIndex] === 'page-content') renderPreview();
    if (steps[currentIndex] === 'review') renderReview();
  }

  backBtn.addEventListener('click', function () {
    if (consultationSending) return;
    if (currentIndex <= 0) return;
    goToStepWithRefresh(currentIndex - 1);
  });

  function goToStepWithRefresh(nextIndex) {
    var steps = visibleSteps();
    if (nextIndex < 0 || nextIndex >= steps.length) return;
    var nextStepId = steps[nextIndex];
    var tag = isMemorialPath() ? 'memorial' : state.pkg;
    var taggedStepId = tag ? (tag + '-' + nextStepId) : nextStepId;
    window.clearTimeout(saveTimer);
    writeStoredState(state);
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('step');
      url.searchParams.delete('package');
      url.searchParams.set('INT', taggedStepId);
      window.location.href = url.toString();
    } catch (err) {
      goToStep(nextIndex);
    }
  }

  nextBtn.addEventListener('click', function () {
    if (consultationSending) return;
    var steps = visibleSteps();
    var curId = steps[currentIndex];
    if (curId === 'review') {
      submitConsultation();
      return;
    }
    if (curId === 'meet' && isMemorialPath()) { submitConsultation(); return; }
    if (curId === 'page-content' && state.pkg !== 'sonata') {
      if (!validateStep(curId)) return;
      submitForm();
      return;
    }
    if (!validateStep(curId)) return;
    goToStepWithRefresh(currentIndex + 1);
  });

  var breakdownModal = document.getElementById('breakdownModal');
  var breakdownModalTitle = document.getElementById('breakdownModalTitle');
  var breakdownModalPrice = document.getElementById('breakdownModalPrice');
  var breakdownModalList = document.getElementById('breakdownModalList');
  var breakdownModalAddOns = document.getElementById('breakdownModalAddOns');
  var breakdownModalClose = document.getElementById('breakdownModalClose');
  var breakdownModalBackdrop = document.getElementById('breakdownModalBackdrop');

  function openBreakdownModal() {
    if (!state.pkg) return;
    var def = PACKAGES[state.pkg];
    breakdownModalTitle.textContent = "What's included in " + def.label;
    breakdownModalPrice.textContent = state.pkg === 'sonata'
      ? 'From $' + amt(PACKAGES.sonata.base) + ' CAD'
      : '$' + amt(packageTotal()) + ' CAD';

    var coreItems = def.items.filter(function (i) { return i.core; });
    breakdownModalList.innerHTML = coreItems
      .map(function (i) { return '<li>' + i.label + (i.note ? ' (' + i.note + ')' : '') + '</li>'; })
      .join('');

    var selectedAddOns = def.items.filter(function (i) {
      return !i.core && state.items[state.pkg][i.id];
    });
    breakdownModalAddOns.innerHTML = selectedAddOns.length
      ? '<p class="wiz-modal__subhead">Your add-ons</p><ul class="wiz-modal__list">' +
          selectedAddOns.map(function (i) {
            return '<li>' + i.label + (i.price === null ? ' (+$X CAD)' : i.price ? ' (+$' + amt(i.price) + ' CAD)' : ' (complimentary)') + '</li>';
          }).join('') +
        '</ul>'
      : '';

    breakdownModal.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeBreakdownModal() {
    breakdownModal.hidden = true;
    document.body.style.overflow = '';
  }
  viewBreakdownBtn.addEventListener('click', openBreakdownModal);
  breakdownModalClose.addEventListener('click', closeBreakdownModal);
  breakdownModalBackdrop.addEventListener('click', closeBreakdownModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !breakdownModal.hidden) closeBreakdownModal();
  });

  function evalCondition(expr) {
    var neg = expr.indexOf('!=') !== -1;
    var parts = expr.split(neg ? '!=' : '=');
    var field = parts[0], values = (parts[1] || '').split(',');
    var current = state[field];
    var matches = values.indexOf(current) !== -1;
    return neg ? !matches : matches;
  }
  function refreshVisibility() {
    document.querySelectorAll('[data-visible-if]').forEach(function (el) {
      var show = evalCondition(el.getAttribute('data-visible-if'));
      el.style.display = show ? '' : 'none';
    });
  }

  function wireGroup(container, onChange) {
    if (!container) return;
    var field = container.dataset.group;
    var items = container.querySelectorAll('.wiz-tile, .wiz-pkg-tab');
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        state[field] = item.dataset.value;
        items.forEach(function (i) { i.classList.toggle('is-selected', i === item); });
        clearError(container.closest('.wiz-field'));
        refreshVisibility();
        saveState();
        if (onChange) onChange(item.dataset.value);
      });
      if (state[field] === item.dataset.value) item.classList.add('is-selected');
    });
  }
  document.querySelectorAll('[data-group]').forEach(function (g) {
    if (g.id === 'pkgTabs') return;
    if (g.dataset.group === 'contactMethod') return;
    if (g.dataset.group === 'forWhom') return;
    wireGroup(g);
  });
  wireGroup(document.querySelector('[data-group="forWhom"]'), function () {
    state.recipientNames = [''];
    state.giverName = '';
    renderRecipientNames();
    var giverInput = document.getElementById('giverName');
    if (giverInput) giverInput.value = '';
    updateMelodyPreview();
    updateGiftNoteCopy();
    updateStoryHint();
    revealStoryRestFields();
    updateRelationshipVisibility();
  });

  function revealStoryRestFields() {
    var rest = document.getElementById('storyRestFields');
    if (rest) rest.hidden = !state.forWhom;
  }

  function updateGiftNoteCopy() {
    var giftNoteEl = document.getElementById('giftNote');
    var giftNoteHint = document.getElementById('giftNoteHint');
    if (!giftNoteEl) return;
    if (state.forWhom === 'myself') {
      giftNoteEl.placeholder = "Whatever you want this page to say to you, later. Why you had this written, what's going on right now, what you hope you remember when you hear it again.";
      if (giftNoteHint) giftNoteHint.textContent = "The fuller note that follows the cover message once you open the page. We've drafted one from what you've told us: make it your own, or leave it as it is.";
    } else {
      giftNoteEl.placeholder = "Dear Sarah,\n\nI had a song written for you. It's an original piece of piano music, composed from our story and the years we've shared.\n\nI hope it says everything I don't always find the words for, and that you think of this moment every time you hear it.\n\nBest, Alex";
      if (giftNoteHint) giftNoteHint.textContent = "The fuller note that follows the cover message once they open the page. We've drafted one from what you've told us: make it your own, or leave it as it is.";
    }

    var pageH1 = document.getElementById('pageContentH1');
    var coverLabel = document.getElementById('coverMessageLabel');
    var coverHint = document.getElementById('coverMessageHint');
    if (state.forWhom === 'myself') {
      if (pageH1) pageH1.textContent = 'What goes on your page.';
      if (coverLabel) coverLabel.textContent = "Your page's cover message";
      if (coverHint) coverHint.textContent = "The first line you'll see when you open the page. We've drafted one, but feel free to change it.";
    } else {
      if (pageH1) pageH1.textContent = 'What goes on their page.';
      if (coverLabel) coverLabel.textContent = "Their page's cover message";
      if (coverHint) coverHint.textContent = "The first line they'll see when they open the page. We've drafted one, but feel free to change it.";
    }
  }

  function updateStoryHint() {
    var hint = document.getElementById('storyHint');
    if (!hint) return;
    if (isMemorialPath()) {
      hint.textContent = "Entirely optional, whatever's easiest. We can cover everything else on the call.";
    } else if (state.pkg === 'sonata') {
      hint.textContent = "This is for your composer's context only. You'll cover the rest together on your consultation call.";
    } else if (state.forWhom === 'myself') {
      hint.textContent = "This is for your composer's context only, and won't appear on the reveal page. The messages on the next step are what you'll actually see.";
    } else {
      hint.textContent = "This is for your composer's context only, and won't appear on the reveal page. The messages on the next step are what they'll actually see.";
    }
  }

  function updateMeetCopy() {
    var h1 = document.getElementById('meetH1');
    var sub = document.getElementById('meetSub');
    if (!h1) return;
    if (isMemorialPath()) {
      h1.textContent = "We're so sorry for your loss.";
      sub.textContent = "Every memorial begins with a consultation call. Tell us your availability below and a composer will reach out to schedule a short phone call to discuss the details.";
    } else {
      h1.textContent = "Let's find time to meet your composer.";
      sub.textContent = "A Sonata begins with a complimentary consultation call before anything is written or billed. Tell us your availability and we'll take it from there.";
    }
  }

  function updateMelodyPreview() {
    var hasRecipientName = state.recipientNames.some(function (n) { return n.trim(); });
    var recipient = formatNameList(state.recipientNames) || "the recipient's name";

    var firstRecipientInput = document.querySelector('#recipientNameList .wiz-input');
    if (firstRecipientInput) {
      firstRecipientInput.placeholder = state.forWhom === 'myself' ? 'Your name' : 'Who is this piece for?';
    }

    var previewEl = document.getElementById('melodyPreview');
    if (!previewEl) return;
    var nameCount = state.recipientNames.filter(function (n) { return n.trim(); }).length;
    previewEl.textContent = hasRecipientName
      ? 'Your composer will use the letters of ' + (nameCount > 1 ? 'the names' : 'the name') + ' "' + recipient +
        '" as the foundation of the melody.'
      : '';

    updateCoverMessageDefault();
  }

  var COVER_OCCASION_PHRASES = {
    'Wedding': 'for your wedding',
    'Memorial': 'in their memory',
    'Engagement': 'to celebrate your engagement',
    'Proposal': 'for you, to go with a very important question',
    'Anniversary': 'for your anniversary',
    'Birthday': 'for your birthday',
    'Graduation': 'to celebrate your graduation',
    'Retirement': 'to celebrate your retirement',
    'New Baby': 'to welcome your new baby',
    'Baby Shower': 'for your baby shower',
    'Housewarming': 'to celebrate your new home',
    "Valentine's Day": "for you this Valentine's Day",
    "Mother's Day": "for you this Mother's Day",
    "Father's Day": "for you this Father's Day",
    'Get Well Soon': 'for you, to help you feel better',
    'Apology': 'for you, to say sorry',
    'Farewell': 'for you, to say goodbye',
    'Reunion': 'to celebrate your reunion',
    'Just Because': 'for you, just because'
  };
  function computeDefaultCoverMessage() {
    var phrase = COVER_OCCASION_PHRASES[state.occasion] || 'for you';
    var recipient = formatNameList(state.recipientNames);
    var giver = String(state.giverName || '').trim();
    var subject = state.forWhom === 'myself' ? 'you' : (giver || 'someone');
    if (state.forWhom === 'myself') {
      phrase = phrase === 'for you' ? 'for yourself' : phrase.replace(/^for you,? /, '');
    }
    var sentence = subject + ' commissioned an original piece of piano music ' + phrase + '.';
    if (recipient) return recipient + ', ' + sentence;
    return sentence.charAt(0).toUpperCase() + sentence.slice(1);
  }
  function computeDefaultCountdownMessage() {
    var phrase = COVER_OCCASION_PHRASES[state.occasion] || 'for you';
    if (phrase === 'for you') phrase = 'just for you';
    var giver = String(state.giverName || '').trim();
    var asker = state.forWhom === 'myself' ? 'You' : giver;
    var opening = asker
      ? asker + " asked a classical music composer to write an original piece of piano music " + phrase + ". "
      : "A classical music composer is writing an original piece of piano music " + phrase + ". ";
    return opening + "When it's finished, it will appear on this page for you to hear.";
  }
  function updateCountdownMessageDefault() {
    if (state.countdownMessageEdited) return;
    var next = computeDefaultCountdownMessage();
    if (next === state.countdownMessage) return;
    state.countdownMessage = next;
    var el = document.getElementById('countdownMessage');
    if (el) el.value = next;
    if (typeof schedulePreviewRender === 'function') schedulePreviewRender();
  }
  function updateCoverMessageDefault() {
    updateGiftNoteDefault();
    updateCountdownMessageDefault();
    var input = document.getElementById('coverMessage');
    if (!input) return;
    if (state.coverMessageEdited) return;
    var next = computeDefaultCoverMessage();
    state.coverMessage = next;
    input.value = next;
  }

  var FORMAL_RELATIONSHIPS = ['Colleague', 'Boss or mentor', 'Teacher', 'Student or mentee', 'Neighbor'];
  function computeDefaultGiftNote() {
    var phrase = COVER_OCCASION_PHRASES[state.occasion] || 'for you';
    var names = formatNameList(state.recipientNames);
    var lines = [];
    if (state.forWhom === 'myself') {
      phrase = phrase === 'for you' ? 'for yourself' : phrase.replace(/^for you,? /, '');
      if (names) lines.push(names + ',');
      lines.push('You had this song written ' + phrase + ", so you'd always have a way back to this moment.");
      lines.push('Whenever you hear it, remember how it felt.');
      return lines.join('\n\n');
    }
    var formal = FORMAL_RELATIONSHIPS.indexOf(state.relationship) !== -1;
    var giver = String(state.giverName || '').trim();
    if (names) lines.push('Dear ' + names + ',');
    lines.push('I had a song written ' + phrase + ". It's an original piece of piano music, written from scratch just for you.");
    lines.push(formal
      ? 'I hope you enjoy it, and that it brings back this moment every time you hear it.'
      : "I hope it says everything I don't always find the words for, and that you think of this moment every time you hear it.");
    if (giver) lines.push((formal ? 'Warmly,' : 'Best,') + '\n' + giver);
    return lines.join('\n\n');
  }
  function updateGiftNoteDefault() {
    var input = document.getElementById('giftNote');
    if (!input || state.giftNoteEdited) return;
    var next = computeDefaultGiftNote();
    if (next === state.giftNote) return;
    state.giftNote = next;
    input.value = next;
    schedulePreviewRender();
  }

  function clearError(fieldEl) { if (fieldEl) fieldEl.classList.remove('has-error'); }
  function setError(fieldEl) { if (fieldEl) fieldEl.classList.add('has-error'); }

  var MAX_RECIPIENT_NAMES = 4;
  var recipientNameListEl = document.getElementById('recipientNameList');
  var addRecipientNameBtn = document.getElementById('addRecipientNameBtn');

  function updateRelationshipVisibility() {
    var field = document.getElementById('relationshipField');
    if (!field) return;
    var nameCount = state.recipientNames.filter(function (n) { return n.trim(); }).length;
    field.hidden = !(state.forWhom === 'someone-else' || (state.forWhom === 'myself' && nameCount > 1));
  }

  function renderRecipientNames() {
    recipientNameListEl.innerHTML = '';
    state.recipientNames.forEach(function (name, i) {
      var row = document.createElement('div');
      row.className = 'wiz-name-list__row';

      var input = document.createElement('input');
      input.type = 'text';
      input.className = 'wiz-input';
      input.id = 'recipientName' + i;
      input.name = 'recipientName' + i;
      if (i > 0) input.setAttribute('aria-label', 'Another name (' + (i + 1) + ')');
      input.value = name;
      input.placeholder = i === 0
        ? (state.forWhom === 'myself' ? 'Your name' : 'Who is this piece for?')
        : 'Another name';
      input.addEventListener('input', function () {
        state.recipientNames[i] = input.value;
        clearError(document.getElementById('recipientNameError').closest('.wiz-field'));
        saveState();
        updateMelodyPreview();
        updateRelationshipVisibility();
      });
      row.appendChild(input);

      if (state.recipientNames.length > 1) {
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'wiz-name-list__remove';
        removeBtn.setAttribute('aria-label', 'Remove this name');
        removeBtn.textContent = '\u00d7';
        removeBtn.addEventListener('click', function () {
          state.recipientNames.splice(i, 1);
          saveState();
          renderRecipientNames();
          updateMelodyPreview();
          updateRelationshipVisibility();
        });
        row.appendChild(removeBtn);
      }

      recipientNameListEl.appendChild(row);
    });
    addRecipientNameBtn.hidden = state.recipientNames.length >= MAX_RECIPIENT_NAMES;
  }
  addRecipientNameBtn.addEventListener('click', function () {
    if (state.recipientNames.length >= MAX_RECIPIENT_NAMES) return;
    state.recipientNames.push('');
    saveState();
    renderRecipientNames();
    updateRelationshipVisibility();
  });

  function bindText(id, field, opts) {
    var el = document.getElementById(id);
    if (!el) return;
    el.value = state[field] || '';
    el.addEventListener('input', function () {
      state[field] = el.value;
      clearError(el.closest('.wiz-field'));
      if (opts && opts.onInput) opts.onInput(el.value);
      saveState();
    });
  }
  function bindCheckbox(id, field) {
    var el = document.getElementById(id);
    if (!el) return;
    el.checked = !!state[field];
    el.addEventListener('change', function () { state[field] = el.checked; saveState(); });
  }
  function bindSelect(id, field, opts) {
    var el = document.getElementById(id);
    if (!el) return;
    el.value = state[field] || '';
    el.addEventListener('change', function () {
      state[field] = el.value;
      clearError(el.closest('.wiz-field'));
      refreshVisibility();
      if (opts && opts.onChange) opts.onChange(el.value);
      saveState();
    });
  }

  bindSelect('occasion', 'occasion', { onChange: function () {
    updateCoverMessageDefault();
    updateStoryHint();
    updateMeetCopy();
    renderProgress();
    renderFooter();
  } });
  bindText('occasionOther', 'occasionOther', { onInput: function () {
    updateCoverMessageDefault();
    updateStoryHint();
    updateMeetCopy();
    renderProgress();
    renderFooter();
  } });
  renderRecipientNames();
  bindSelect('relationship', 'relationship', { onChange: updateGiftNoteDefault });
  bindText('relationshipOther', 'relationshipOther');
  bindText('giverName', 'giverName', { onInput: updateMelodyPreview });
  (function () {
    var el = document.getElementById('giftNote');
    if (!el) return;
    if (!state.giftNoteEdited && !state.giftNote) state.giftNote = computeDefaultGiftNote();
    el.value = state.giftNote || '';
    el.addEventListener('input', function () {
      state.giftNote = el.value;
      state.giftNoteEdited = true;
      saveState();
      schedulePreviewRender();
    });
  })();
  bindText('eventDetails', 'eventDetails');
  (function () {
    var el = document.getElementById('countdownMessage');
    if (!el) return;
    if (!state.countdownMessageEdited) state.countdownMessage = computeDefaultCountdownMessage();
    el.value = state.countdownMessage || '';
    el.addEventListener('input', function () {
      state.countdownMessage = el.value;
      state.countdownMessageEdited = true;
      saveState();
      schedulePreviewRender();
    });
  })();
  bindText('contactValue', 'contactValue');
  bindText('contactPhone', 'contactPhone');
  bindText('occasionDate', 'occasionDate', { onInput: function () { checkDateWarning(); renderTimeline(); } });
  bindCheckbox('noDateYet', 'noDateYet');
  bindSelect('referralSource', 'referralSource');
  bindText('referralSourceOther', 'referralSourceOther');
  bindCheckbox('agreeTerms', 'agreeTerms');
  bindCheckbox('keepPrivate', 'keepPrivate');

  (function () {
    var dateInput = document.getElementById('occasionDate');
    var noDateBox = document.getElementById('noDateYet');
    var t = new Date();
    dateInput.min = t.getFullYear() + '-' + String(t.getMonth() + 1).padStart(2, '0') + '-' + String(t.getDate()).padStart(2, '0');
    dateInput.disabled = !!state.noDateYet;
    noDateBox.addEventListener('change', function (e) {
      dateInput.disabled = e.target.checked;
      clearError(dateInput.closest('.wiz-field'));
      if (e.target.checked) { dateInput.value = ''; state.occasionDate = ''; document.getElementById('dateWarning').style.display = 'none'; saveState(); }
      renderTimeline();
    });
  })();

  bindText('soundRequest', 'soundRequest');

  var storyEl = document.getElementById('story');
  var storyCount = document.getElementById('storyCount');
  storyEl.value = state.story || '';
  storyCount.textContent = storyEl.value.length;
  storyEl.addEventListener('input', function () {
    state.story = storyEl.value;
    storyCount.textContent = storyEl.value.length;
    clearError(storyEl.closest('.wiz-field'));
    saveState();
  });

  var coverMessageEl = document.getElementById('coverMessage');
  if (!state.coverMessage) state.coverMessage = computeDefaultCoverMessage();
  coverMessageEl.value = state.coverMessage;
  coverMessageEl.addEventListener('input', function () {
    state.coverMessage = coverMessageEl.value;
    state.coverMessageEdited = true;
    saveState();
    schedulePreviewRender();
  });

  var contactValueEl = document.getElementById('contactValue');
  function updateContactPlaceholder() {
    contactValueEl.placeholder = state.contactMethod === 'phone' ? '(416) 555-0110' : 'you@email.com';
    contactValueEl.type = state.contactMethod === 'phone' ? 'tel' : 'email';
  }
  wireGroup(document.querySelector('[data-group="contactMethod"]'), updateContactPlaceholder);
  if (!state.contactMethod) state.contactMethod = 'email';
  updateContactPlaceholder();

  var CONTACT_PAGE_URL = '/pages/contact-us';
  function setTextWithContactLink(el, message) {
    el.textContent = '';
    String(message || '').split(/\[([^\]]+)\]/).forEach(function (part, i) {
      if (i % 2 === 0) { if (part) el.appendChild(document.createTextNode(part)); return; }
      var a = document.createElement('a');
      a.href = CONTACT_PAGE_URL;
      a.target = '_blank';
      a.rel = 'noopener';
      a.style.textDecoration = 'underline';
      a.style.color = 'inherit';
      a.textContent = part;
      el.appendChild(a);
    });
  }

  function checkDateWarning() {
    var warn = document.getElementById('dateWarning');
    if (!state.occasionDate) { warn.style.display = 'none'; return; }
    var chosen = new Date(state.occasionDate + 'T00:00:00');
    var days = Math.round((chosen - new Date()) / 86400000);
    if (days >= 0 && days < 21) {
      setTextWithContactLink(warn, "That's less than three weeks away, and a Sonatina usually takes 2 to 3 weeks. " +
        "Consider rush delivery (one week) on the package step, or a free countdown page so they have something to open on the day. " +
        "Need it sooner still? [Contact us] and we'll see what's possible.");
      warn.style.display = 'block';
    } else {
      warn.style.display = 'none';
    }
  }
  checkDateWarning();

  function isValidContactValue() {
    var v = state.contactValue.trim();
    if (!v) return false;
    if (state.contactMethod === 'phone') {
      var digits = v.replace(/\D/g, '');
      return digits.length >= 10 && digits.length <= 15;
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
  }
  function updateContactValueError() {
    var errorEl = document.getElementById('contactValueError');
    if (!errorEl) return;
    if (!state.contactValue.trim()) {
      errorEl.textContent = 'We need your email address before continuing.';
    } else if (state.contactMethod === 'phone') {
      errorEl.textContent = "That doesn't look like a complete phone number.";
    } else {
      errorEl.textContent = "That doesn't look like a valid email address.";
    }
  }

  function fieldStepId(el) {
    var sec = el && el.closest ? el.closest('.wiz-step') : null;
    return sec ? sec.getAttribute('data-step') : null;
  }
  function validateLocatedFields(stepId) {
    var ok = true;
    // A field only counts if it's on this step and not hidden by any data-visible-if wrapper around it.
    function here(id) {
      var el = document.getElementById(id);
      if (!el || fieldStepId(el) !== stepId) return false;
      for (var gate = el.closest('[data-visible-if]'); gate; gate = gate.parentElement && gate.parentElement.closest('[data-visible-if]')) {
        if (!evalCondition(gate.getAttribute('data-visible-if'))) return false;
      }
      return true;
    }
    function fail(id) { setError(document.getElementById(id).closest('.wiz-field')); ok = false; }
    if (here('referralSource') && !state.referralSource) fail('referralSource');
    if (here('referralSourceOther') && state.referralSource === 'Other' && !state.referralSourceOther.trim()) fail('referralSourceOther');
    if (here('contactValue') && !isValidContactValue()) { updateContactValueError(); fail('contactValue'); }
    if (here('contactPhone') && String(state.contactPhone || '').replace(/\D/g, '').length < 10) fail('contactPhone');
    if (here('agreeTerms') && !document.getElementById('agreeTerms').checked) fail('agreeTerms');
    if (here('occasionDate') && !state.occasionDate && !state.noDateYet) fail('occasionDate');
    return ok;
  }

  function validateIntro() {
    var ok = true;
    function fail(fieldEl) { setError(fieldEl); ok = false; }

    if (!state.forWhom) fail(document.querySelector('[data-group="forWhom"]').closest('.wiz-field'));
    if (!state.occasion) fail(document.getElementById('occasion').closest('.wiz-field'));
    if (state.occasion === 'Other' && !state.occasionOther.trim()) fail(document.getElementById('occasionOther').closest('.wiz-field'));
    if (!state.recipientNames.some(function (n) { return n.trim(); })) fail(document.getElementById('recipientNameList').closest('.wiz-field'));
    if (!validateLocatedFields('intro')) ok = false;

    if (!ok) { var e = document.querySelector('.has-error'); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }

  function validateDetails() {
    var ok = true;
    function fail(fieldEl) { setError(fieldEl); ok = false; }

    if (state.pkg === 'sonata') {
      if (String(state.eventDetails || '').trim().length < 20) fail(document.getElementById('eventDetails').closest('.wiz-field'));
    } else if (!isMemorialPath() && state.story.trim().length < 20) {
      fail(storyEl.closest('.wiz-field'));
    }
    if (!validateLocatedFields('details')) ok = false;

    if (!ok) { var e = document.querySelector('.has-error'); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }

  function validatePageContent() {
    var ok = true;
    function fail(fieldEl) { setError(fieldEl); ok = false; }

    if (!validateLocatedFields('page-content')) ok = false;

    if (!ok) { var e = document.querySelector('.has-error'); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }

  var pkgTabsEl = document.getElementById('pkgTabs');
  var pkgCardEl = document.getElementById('pkgCard');
  var uploadBlock = document.getElementById('uploadBlock');

  function pkgPriceAt(pkgId) {
    var def = PACKAGES[pkgId];
    if (!def) return 0;
    var total = hasPrice(def.base) ? def.base : NaN;
    def.items.forEach(function (item) {
      if (item.core) return;
      var checked = state.items[pkgId][item.id];
      var p = hasPrice(item.price) ? item.price : NaN;
      if (checked && !item.def) total += p;
      if (!checked && item.def) total -= p;
    });
    return total;
  }
  function packageTotal() { return pkgPriceAt(state.pkg); }

  function renderPkgTabs() {
    pkgTabsEl.innerHTML = '';
    PKG_ORDER.forEach(function (pkgId) {
      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'wiz-pkg-tab' + (state.pkg === pkgId ? ' is-selected' : '');
      tab.setAttribute('data-button-name', 'checkout | package | ' + pkgId);
      var tabPricePrefix = pkgId === 'sonata' ? 'from $' : '$';
      tab.innerHTML = PACKAGES[pkgId].label + '<span class="wiz-pkg-tab__price">' + tabPricePrefix + amt(PACKAGES[pkgId].base) + ' CAD</span>';
      tab.addEventListener('click', function () {
        if (state.pkg === pkgId) {
          state.pkg = null;
          state.pkgTouched = false;
        } else {
          state.pkg = pkgId;
          state.pkgTouched = true;
        }
        clearError(pkgTabsEl.closest('.wiz-field'));
        saveState();
        renderPkgTabs();
        renderPkgCard();
        renderFooter();
        updateStoryHint();
        refreshVisibility();
      });
      pkgTabsEl.appendChild(tab);
    });
  }

  function deliveryDateObj() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + (state.items.sonatina && state.items.sonatina.rush ? 7 : 21));
    return d;
  }
  function deliveryDateLabel() {
    return deliveryDateObj().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  }
  function renderTimeline() {
    var el = document.getElementById('pkgTimeline');
    if (!el) return;
    if (!state.pkg || !state.occasionDate || state.noDateYet) { el.hidden = true; el.textContent = ''; return; }
    function mk(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    el.textContent = '';
    if (state.pkg === 'sonata') {
      el.appendChild(mk('p', 'label wiz-timeline__label', 'Timeline'));
      el.appendChild(mk('p', 'wiz-field__hint wiz-timeline__text', "We'll decide on the timeline during your consultation call."));
      el.hidden = false;
      return;
    }
    var DAY = 86400000;
    var rush = !!(state.items.sonatina && state.items.sonatina.rush);
    var today = new Date(); today.setHours(0, 0, 0, 0);
    var total = rush ? 7 : 21;
    var occ = new Date(state.occasionDate + 'T00:00:00');
    var occDay = Math.max(0, Math.round((occ - today) / DAY));
    var late = total > occDay;
    var span = Math.max(total, occDay, 1);
    var fmt = function (days) {
      var d = new Date(today.getTime());
      d.setDate(d.getDate() + days);
      return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    };
    var marks = [
      { key: 'order', name: 'Order placed', day: 0 },
      { key: 'draft', name: 'First draft', day: Math.round(total / 2) },
      { key: 'delivered', name: 'Delivered', day: total },
      { key: 'occasion', name: 'Occasion date', day: occDay }
    ];
    el.appendChild(mk('p', 'label wiz-timeline__label', 'Delivery timeline'));
    var sorted = marks.slice().sort(function (x, y) { return x.day - y.day; });
    var pos = sorted.map(function (m, idx) { return idx / (sorted.length - 1) * 100; });
    var track = mk('div', 'wiz-timeline__track');
    var line = mk('span', 'wiz-timeline__line');
    var fill = mk('span', 'wiz-timeline__fill');
    var deliveredAt = 0;
    sorted.forEach(function (m, idx) { if (m.key === 'delivered') deliveredAt = pos[idx]; });
    fill.style.width = deliveredAt + '%';
    line.appendChild(fill);
    track.appendChild(line);
    sorted.forEach(function (m, idx) {
      var mark = mk('div', 'wiz-timeline__mark ' + 'is-above');
      mark.style.left = pos[idx] + '%';
      mark.appendChild(mk('span', 'wiz-timeline__dot wiz-timeline__dot--' + m.key));
      var txt = mk('span', 'wiz-timeline__caption');
      txt.appendChild(mk('span', 'wiz-timeline__name', m.name));
      txt.appendChild(mk('span', 'wiz-timeline__when', fmt(m.day)));
      mark.appendChild(txt);
      track.appendChild(mark);
    });
    el.appendChild(track);
    var note = mk('p', 'wiz-field__hint wiz-timeline__text ' + (late ? 'wiz-timeline__late' : 'wiz-timeline__ok'));
    note.textContent = late
      ? (rush ? 'Your piece would arrive after the occasion. Add the free countdown page so they have something to open on the day, or contact us about an earlier date.'
              : 'Your piece would arrive after the occasion. Add rush delivery (one week) or the free countdown page.')
      : 'Your piece arrives in time for the occasion.';
    el.appendChild(note);
    el.hidden = false;
  }

  function renderPkgCard() {
    var pkgId = state.pkg;
    renderTimeline();
    var sonataPayNote = document.getElementById('sonataPayNote');
    if (sonataPayNote) sonataPayNote.hidden = pkgId !== 'sonata';

    if (!pkgId) {
      pkgCardEl.innerHTML = '<p class="wiz-pkg-note" style="margin:0;">Choose a package above to see what\'s included.</p>';
      uploadBlock.classList.remove('is-visible');
      return;
    }

    var def = PACKAGES[pkgId];
    var startingDisplay = pkgId === 'sonata'
      ? 'From $' + amt(def.base) + ' CAD'
      : '$' + amt(def.base) + ' CAD';
    var totalDisplay = pkgId === 'sonata'
      ? 'From $' + amt(def.base) + ' CAD'
      : '$' + amt(pkgPriceAt(pkgId)) + ' CAD';

    pkgCardEl.innerHTML =
      '<div class="wiz-pkg-card__head">' +
        '<h2 class="wiz-pkg-card__name">' + def.label + '</h2>' +
        '<p class="wiz-pkg-card__starting">' + startingDisplay + '</p>' +
      '</div>' +
      '<p class="wiz-pkg-card__summary">' + def.summary + '</p>' +
      '<div class="wiz-item-list" id="itemList"></div>' +
      '<div class="wiz-pkg-total"><span class="wiz-pkg-total__label">Total</span><span class="wiz-pkg-total__value" id="pkgTotalValue">' + totalDisplay + '</span></div>';

    var listEl = document.getElementById('itemList');
    def.items.forEach(function (item) {
      var checked = state.items[pkgId][item.id];
      var row = document.createElement('div');
      row.className = 'wiz-item' + (item.core ? ' is-core' : '') + (checked ? ' is-checked' : '');
      var priceTag = item.core ? 'Included'
        : item.price === null ? (checked ? '+$X CAD' : '$X CAD extra')
        : !item.price ? 'Complimentary'
        : (checked ? (item.def ? 'Included' : ('+$' + amt(item.price) + ' CAD')) : ('$' + amt(item.price) + ' CAD extra'));
      row.innerHTML =
        '<button type="button" class="wiz-item__hit"' + (item.core ? ' disabled' : ' data-button-name="checkout | add-on | ' + item.id + '"') + '>' +
          '<span class="wiz-item__box"></span>' +
          '<span class="wiz-item__body"><p class="wiz-item__label">' + item.label + '</p>' +
            (item.note ? '<p class="wiz-item__note">' + item.note + '</p>' : '') +
          '</span>' +
          '<span class="wiz-item__price">' + priceTag + '</span>' +
        '</button>';
      if (!item.core) {
        row.querySelector('.wiz-item__hit').addEventListener('click', function () {
          state.items[pkgId][item.id] = !state.items[pkgId][item.id];
          saveState();
          renderPkgCard();
          renderFooter();
          if (item.id === 'countdown' || item.id === 'rush') refreshCountdown();
        });
      }
      listEl.appendChild(row);
    });

    uploadBlock.classList.toggle('is-visible', pkgId !== 'sonata' && !!state.items[pkgId].slideshow);
  }

  renderPkgTabs();
  renderPkgCard();

  var dateStripEl = document.getElementById('dateStrip');
  var slotListEl = document.getElementById('slotList');
  var today = new Date(); today.setHours(0, 0, 0, 0);
  var WEEKS_TO_SHOW = 5;
  var MAX_MEET_SLOTS = 4;

  // CALL TIMES. Calls happen in Toronto time: these weekdays (0 = Sun ... 6 = Sat), in this
  // window. Everything the visitor sees is converted to their own time zone; the request we
  // receive lists each date in both Eastern Time and theirs.
  var BUSINESS_TZ = 'America/Toronto';
  var CALL_WEEKDAYS_ET = [1, 3, 5];
  var CALL_START_HOUR_ET = 18;
  var CALL_END_HOUR_ET = 21;

  var VISITOR_TZ = (function () {
    try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; }
  })();

  function dateKey(y, m, d) {
    return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
  }
  function localKeyOf(dt) { return dateKey(dt.getFullYear(), dt.getMonth(), dt.getDate()); }

  // Offset (ms) of BUSINESS_TZ from UTC at a given instant: Toronto wall clock minus UTC.
  var etParts = null;
  try {
    etParts = new Intl.DateTimeFormat('en-US', {
      timeZone: BUSINESS_TZ, hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
  } catch (e) { etParts = null; }
  function etOffsetAt(ms) {
    if (!etParts) return -5 * 3600000;
    var p = {};
    etParts.formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    var wall = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    return wall - Math.floor(ms / 1000) * 1000;
  }
  // The instant (Date) at which Toronto's wall clock reads y-m-d h:00.
  function etWallToDate(y, m, d, h) {
    var guess = Date.UTC(y, m, d, h);
    var t = guess - etOffsetAt(guess);
    var t2 = guess - etOffsetAt(t);
    return new Date(t2);
  }
  // Today's date in Toronto, as a key.
  function etTodayKey() {
    if (!etParts) return localKeyOf(new Date());
    var p = {};
    etParts.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day;
  }

  // Builds the call slot for a Toronto date key ('2026-10-12'), or null if there are no calls that day.
  function slotForEtKey(etKey) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(etKey || '');
    if (!m) return null;
    var y = +m[1], mo = +m[2] - 1, d = +m[3];
    var weekday = new Date(Date.UTC(y, mo, d)).getUTCDay();
    if (CALL_WEEKDAYS_ET.indexOf(weekday) === -1) return null;
    var start = etWallToDate(y, mo, d, CALL_START_HOUR_ET);
    var end = etWallToDate(y, mo, d, CALL_END_HOUR_ET);
    return { etKey: etKey, start: start, end: end, localKey: localKeyOf(start) };
  }

  // Every bookable slot from tomorrow (Toronto time) for `days` days, keyed by the visitor's local date.
  function slotsByLocalDay(days) {
    var map = {};
    var base = etTodayKey().split('-');
    for (var i = 1; i <= days; i++) {
      var dt = new Date(Date.UTC(+base[0], +base[1] - 1, +base[2] + i));
      var slot = slotForEtKey(dateKey(dt.getUTCFullYear(), dt.getUTCMonth(), dt.getUTCDate()));
      if (slot) map[slot.localKey] = slot;
    }
    return map;
  }

  function fmtTime(dt, tz) {
    var o = { hour: 'numeric', minute: '2-digit' };
    if (tz) o.timeZone = tz;
    try { return dt.toLocaleTimeString('en-US', o); } catch (e) { return dt.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }); }
  }
  function fmtDay(dt, tz, long) {
    var o = long
      ? { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
      : { weekday: 'long', month: 'short', day: 'numeric' };
    if (tz) o.timeZone = tz;
    try { return dt.toLocaleDateString('en-US', o); } catch (e) { delete o.timeZone; return dt.toLocaleDateString('en-US', o); }
  }
  function visitorIsOnEasternTime(slot) {
    return etOffsetAt(slot.start.getTime()) === -slot.start.getTimezoneOffset() * 60000;
  }
  // "Monday, Oct 12, 3:00 PM – 6:00 PM" in the visitor's time zone.
  function localSlotLabel(slot, long) {
    return fmtDay(slot.start, '', long) + ', ' + fmtTime(slot.start) + ' – ' + fmtTime(slot.end);
  }
  function etSlotLabel(slot, long) {
    return fmtDay(slot.start, BUSINESS_TZ, long) + ', ' + fmtTime(slot.start, BUSINESS_TZ) + ' – ' + fmtTime(slot.end, BUSINESS_TZ) + ' Eastern Time';
  }

  function renderTzNote() {
    var el = document.getElementById('meetTzNote');
    if (!el) return;
    var sample = null, map = slotsByLocalDay(14);
    for (var k in map) { sample = map[k]; break; }
    if (!sample) { el.textContent = ''; return; }
    if (visitorIsOnEasternTime(sample)) {
      el.textContent = 'Calls are in the evening, ' + fmtTime(sample.start) + ' to ' + fmtTime(sample.end) + ' Eastern Time.';
    } else {
      el.textContent = 'Dates and times are shown in your time zone' + (VISITOR_TZ ? ' (' + VISITOR_TZ.replace(/_/g, ' ') + ')' : '') +
        '. Calls run ' + fmtTime(sample.start) + ' to ' + fmtTime(sample.end) + ' your time, which is ' +
        fmtTime(sample.start, BUSINESS_TZ) + ' to ' + fmtTime(sample.end, BUSINESS_TZ) + ' Eastern Time.';
    }
  }

  // state.meetSlots keeps each pick as its Toronto date (date: 'YYYY-MM-DD'); labels are rebuilt from it.
  function findSlot(etKey) {
    for (var i = 0; i < state.meetSlots.length; i++) if (state.meetSlots[i].date === etKey) return state.meetSlots[i];
    return null;
  }
  function addSlot(etKey) {
    if (findSlot(etKey) || state.meetSlots.length >= MAX_MEET_SLOTS) return;
    state.meetSlots.push({ date: etKey, times: ['Evening'] });
    saveState();
    renderDateStrip();
    renderSlotList();
    clearError(dateStripEl.closest('.wiz-field'));
  }
  function removeSlot(etKey) {
    state.meetSlots = state.meetSlots.filter(function (s) { return s.date !== etKey; });
    saveState();
    renderDateStrip();
    renderSlotList();
  }

  function renderDateStrip() {
    var earliest = new Date(today);
    earliest.setDate(earliest.getDate() + 1);
    var gridStart = new Date(earliest);
    gridStart.setDate(gridStart.getDate() - gridStart.getDay());
    var bookable = slotsByLocalDay(WEEKS_TO_SHOW * 7 + 7);

    var html = '<div class="wiz-date-grid__head">' +
      ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(function (d) {
        return '<span>' + d + '</span>';
      }).join('') +
      '</div>';
    for (var w = 0; w < WEEKS_TO_SHOW; w++) {
      html += '<div class="wiz-date-grid__row">';
      for (var d = 0; d < 7; d++) {
        var day = new Date(gridStart);
        day.setDate(day.getDate() + w * 7 + d);
        var slot = day >= earliest ? bookable[localKeyOf(day)] : null;
        var dayNum = '<span class="wiz-date-chip__day">' + day.getDate() + '</span>';
        if (slot) {
          var selected = !!findSlot(slot.etKey);
          html += '<button type="button" class="wiz-date-chip' + (selected ? ' is-selected' : '') + '" data-date="' + slot.etKey + '"' +
            ' aria-pressed="' + selected + '" aria-label="' + localSlotLabel(slot).replace(/"/g, '') + '">' + dayNum + '</button>';
        } else {
          html += '<span class="wiz-date-chip wiz-date-chip--disabled" aria-disabled="true">' + dayNum + '</span>';
        }
      }
      html += '</div>';
    }
    dateStripEl.innerHTML = html;
    dateStripEl.querySelectorAll('.wiz-date-chip:not(.wiz-date-chip--disabled)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.dataset.date;
        if (findSlot(key)) removeSlot(key); else addSlot(key);
      });
    });
  }

  var customMeetDateEl = document.getElementById('customMeetDate');
  var addCustomMeetDateBtn = document.getElementById('addCustomMeetDate');
  var customMeetDateError = document.getElementById('customMeetDateError');
  addCustomMeetDateBtn.addEventListener('click', function () {
    if (!customMeetDateEl.value) return;
    // The visitor picks a date in their own calendar; find the call that starts on that local day.
    var p = customMeetDateEl.value.split('-');
    var picked = new Date(+p[0], +p[1] - 1, +p[2]);
    var earliest = new Date(today);
    earliest.setDate(earliest.getDate() + 1);
    var match = null;
    if (picked >= earliest) {
      for (var off = -1; off <= 1 && !match; off++) {
        var c = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + off));
        var s = slotForEtKey(dateKey(c.getUTCFullYear(), c.getUTCMonth(), c.getUTCDate()));
        if (s && s.localKey === customMeetDateEl.value && s.etKey > etTodayKey()) match = s;
      }
    }
    customMeetDateError.style.display = match ? 'none' : 'block';
    if (!match) return;
    addSlot(match.etKey);
    customMeetDateEl.value = '';
  });

  function renderSlotList() {
    slotListEl.innerHTML = '';
    state.meetSlots
      .slice()
      .sort(function (a, b) { return a.date < b.date ? -1 : 1; })
      .forEach(function (saved) {
        var slot = slotForEtKey(saved.date);
        var row = document.createElement('div');
        row.className = 'wiz-slot';
        var label = document.createElement('span');
        label.className = 'wiz-slot__date';
        label.textContent = slot ? localSlotLabel(slot) : saved.date;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'wiz-slot__remove';
        btn.textContent = 'Remove';
        btn.addEventListener('click', function () { removeSlot(saved.date); });
        row.appendChild(label);
        row.appendChild(btn);
        slotListEl.appendChild(row);
      });
  }

  // Drop saved picks that are no longer bookable (in the past, or no longer a call day).
  (function pruneSlots() {
    var etToday = etTodayKey();
    var kept = (state.meetSlots || []).filter(function (s) {
      return s && s.date > etToday && !!slotForEtKey(s.date);
    });
    if (kept.length !== (state.meetSlots || []).length) { state.meetSlots = kept; writeStoredState(state); }
  })();

  renderTzNote();
  renderDateStrip();
  renderSlotList();

  function validatePackage() {
    var ok = validateLocatedFields('package');
    if (!state.pkg) { setError(pkgTabsEl.closest('.wiz-field')); ok = false; }
    if (!ok) { var e = document.querySelector('.has-error'); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }

  function validateMeet() {
    var ok = validateLocatedFields('meet');
    if (state.pkg !== 'sonata' && !isMemorialPath()) return ok;
    var hasSlot = state.meetSlots.some(function (s) { return s.times.length > 0; });
    if (!hasSlot) { setError(dateStripEl.closest('.wiz-field')); ok = false; }
    if (!ok) { var e = document.querySelector('.has-error'); if (e) e.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    return ok;
  }

  function showConfirmation(title, text) {
    document.getElementById('confirmationTitle').textContent = title;
    document.getElementById('confirmationText').textContent = text;
    var steps = visibleSteps();
    var idx = steps.indexOf('confirmation');
    if (idx !== -1) goToStep(idx);
    clearStoredState();
    deleteLegacyCookies();
  }

  function buildConsultationMessage() {
    var memorial = isMemorialPath();
    var occasionLabel = state.occasion === 'Other'
      ? (state.occasionOther || 'Other')
      : (state.occasion || '');
    var relationshipLabel = state.relationship === 'Other'
      ? (state.relationshipOther || 'Other')
      : (state.relationship || '');
    var referralLabel = state.referralSource === 'Other'
      ? (state.referralSourceOther || 'Other')
      : (state.referralSource || '');
    var recipients = (state.recipientNames || []).map(function (n) { return String(n || '').trim(); }).filter(Boolean);
    var slots = state.meetSlots
      .filter(function (s) { return s.times && s.times.length; })
      .slice()
      .sort(function (a, b) { return a.date < b.date ? -1 : 1; })
      .map(function (s) {
        var slot = slotForEtKey(s.date);
        if (!slot) return '  - ' + s.date + ' (Eastern Time date)';
        return '  - Eastern: ' + etSlotLabel(slot, true) + '\n' +
               '    Their time: ' + localSlotLabel(slot, true) + (VISITOR_TZ ? ' (' + VISITOR_TZ + ')' : '');
      });

    var lines = [];
    function add(label, value) {
      value = String(value == null ? '' : value).trim();
      if (value) lines.push(label + ': ' + value);
    }
    function block(label, value) {
      value = String(value == null ? '' : value).trim();
      if (value) { lines.push(''); lines.push(label + ':'); lines.push(value); }
    }

    lines.push(memorial ? 'MEMORIAL CONSULTATION REQUEST' : 'SONATA CONSULTATION REQUEST');
    lines.push('Submitted from the Riffloom checkout on ' + new Date().toString());
    lines.push('');
    add('Name', state.giverName);
    add('Email', state.contactValue);
    add('Phone (for the call)', state.contactPhone);
    if (!memorial) add('Package', PACKAGES.sonata.label + ' (from $' + amt(PACKAGES.sonata.base) + ' CAD)');
    add('Call type', 'Phone call');
    add('Who it is for', state.forWhom === 'myself' ? 'Themselves' : (state.forWhom ? 'Someone else' : ''));
    add('Recipient(s)', recipients.join(', '));
    add('Relationship', relationshipLabel);
    add('Occasion', occasionLabel);
    if (!state.noDateYet) add('Occasion date', state.occasionDate);
    else lines.push('Occasion date: not set yet');
    if (memorial) add('How they heard about us', referralLabel);
    add('Their time zone', VISITOR_TZ || 'unknown');
    lines.push('');
    lines.push('Availability (phone call, ' + CALL_START_HOUR_ET + ':00-' + CALL_END_HOUR_ET + ':00 Eastern Time window):');
    lines.push(slots.length ? slots.join('\n') : '  (none given)');
    if (memorial) {
      block('Story', state.story);
      block('Style / genre requests', state.soundRequest);
      block('What they are looking for, for the event', state.eventDetails);
    } else {
      block('About them and their event', state.eventDetails);
    }
    return lines.join('\n');
  }

  var consultFormWired = false;

  function consultLog(msg, extra) {
    try { console.warn('[Sonata submission] ' + msg, extra === undefined ? '' : extra); } catch (e) {}
  }

  function consultationForm() {
    var form = document.getElementById('sonataSubmissionForm');
    if (form && !consultFormWired) {
      consultFormWired = true;
      form.target = CONSULT_FRAME_NAME;
    }
    return form;
  }

  var CONSULT_FRAME_NAME = 'sonataSubmissionFrame';

  function consultationFrame() {
    var frame = document.getElementById(CONSULT_FRAME_NAME);
    if (!frame) {
      frame = document.createElement('iframe');
      frame.id = CONSULT_FRAME_NAME;
      frame.name = CONSULT_FRAME_NAME;
      frame.setAttribute('aria-hidden', 'true');
      frame.setAttribute('tabindex', '-1');
      frame.style.cssText = 'position:absolute;width:1px;height:1px;left:-9999px;top:-9999px;border:0;';
      document.body.appendChild(frame);
    }
    return frame;
  }

  function consultationFailure() {
    return new Error("That didn't send. Please try again, or [contact us] directly.");
  }

  function sendConsultationRequest(data) {
    data = data || {};
    var form = consultationForm();
    if (!form) return Promise.reject(consultationFailure());

    var hp = document.getElementById('sonataSubHp');
    if (hp && hp.value.trim() !== '') return Promise.resolve();

    document.getElementById('sonataSubName').value  = String(data.name  || '').trim();
    document.getElementById('sonataSubEmail').value = String(data.email || '').trim();
    var ref = 'SUB-' + Date.now().toString(36).toUpperCase() +
              Math.random().toString(36).slice(2, 6).toUpperCase();
    document.getElementById('sonataSubBody').value =
      String(data.body || '') + '\n\nReference: ' + ref;

    consultLog('sending ' + ref);

    return new Promise(function (resolve, reject) {
      var settled = false;

      function post() {
        fetch(form.action, {
          method: form.method || 'post',
          body: new FormData(form),
          credentials: 'same-origin'
        }).then(function (res) {
          var status = res && res.status;
          var url = (res && res.url) || '';

          if (/\/challenge(\?|$)/.test(url)) {
            consultLog(ref + ' needs an interactive challenge - redirecting to ' + url);
            settled = true;
            window.removeEventListener('beforeunload', warnBeforeLeaving);
            window.location.assign(url);
            return;
          }

          // Shopify redirects to ?contact_posted=true only when the message was accepted.
          if (!/[?&]contact_posted=true(&|$)/.test(url)) {
            consultLog('Shopify did not accept the post (status ' + status + ', ' + (url || 'no url') + ') - nothing was sent');
            if (res && res.text) {
              res.text().then(function (t) {
                consultLog('the response said: ' + String(t).replace(/\s+/g, ' ').slice(0, 200));
              }, function () {});
            }
            settled = true;
            reject(consultationFailure());
            return;
          }
          consultLog(ref + ' sent (status ' + status + ', ' + (url || 'no url') + ')');
          settled = true;
          resolve();
        }).catch(function (err) {
          consultLog('network error while sending ' + ref, err);
          settled = true;
          reject(consultationFailure());
        });
      }

      var nativeSubmit = form.submit;
      form.submit = function () {
        consultLog('form.submit() intercepted - token is ready, posting via fetch() instead');
        form.submit = nativeSubmit;
        post();
      };

      setTimeout(function () {
        if (settled) return;
        if (form.submit !== nativeSubmit) {
          consultLog('form.submit() was never called within 15s - giving up and restoring it');
          form.submit = nativeSubmit;
        }
        settled = true;
        reject(consultationFailure());
      }, 15000);

      function triggerRealFlow() {
        consultLog('triggering the real submit flow for ' + ref +
          ' (requestSubmit(), so Shopify\'s captcha handler engages)');
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }

      if (window.Shopify && window.Shopify.captcha &&
          typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form, triggerRealFlow);
      } else {
        consultLog('window.Shopify.captcha.protect is unavailable - proceeding without it');
        triggerRealFlow();
      }
    });
  }

  var consultationSending = false;
  var wizPageEl = document.querySelector('.wiz-page');

  function warnBeforeLeaving(e) { e.preventDefault(); e.returnValue = ''; return ''; }
  function setConsultationSending(on) {
    consultationSending = on;
    if (wizPageEl) {
      wizPageEl.classList.toggle('is-sending', on);
      wizPageEl.setAttribute('aria-busy', on ? 'true' : 'false');
    }
    backBtn.disabled = on;
    nextBtn.disabled = on;
    if (on) window.addEventListener('beforeunload', warnBeforeLeaving);
    else window.removeEventListener('beforeunload', warnBeforeLeaving);
  }

  function showConsultationError(message) {
    var step = document.querySelector('.wiz-step.is-active');
    if (!step) { window.alert(String(message).replace(/\[([^\]]+)\]/g, '$1')); return; }
    var el = document.getElementById('consultSubmitError');
    if (!el) {
      el = document.createElement('p');
      el.id = 'consultSubmitError';
      el.className = 'wiz-field__hint';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'color:var(--bad);margin-top:14px;';
    }
    setTextWithContactLink(el, message);
    step.appendChild(el);
  }
  function clearConsultationError() {
    var el = document.getElementById('consultSubmitError');
    if (el && el.parentNode) el.parentNode.removeChild(el);
  }

  var CONSULT_SENT_KEY = 'riffloomConsultSent_v1';

  function submitConsultation() {
    if (!validateMeet()) {
      var stepsNow = visibleSteps();
      if (stepsNow[currentIndex] === 'review') goToStep(stepsNow.indexOf('meet'));
      return;
    }
    if (consultationSending) return;

    if (!consultationForm()) {
      consultLog('the "Sonata submission" section is not on this page: ' +
        'add it in the theme editor (Add section > Sonata submission).');
      showConsultationError("That didn't send. Please try again, or [contact us] directly.");
      return;
    }

    clearConsultationError();
    var idleLabel = nextBtn.textContent;
    setConsultationSending(true);
    nextBtn.textContent = 'Sending…';

    sendConsultationRequest({
      name: state.giverName,
      email: state.contactValue,
      body: buildConsultationMessage()
    }).then(function () {
      setConsultationSending(false);
      nextBtn.textContent = idleLabel;
      showConsultationSuccess();
    }, function (err) {
      setConsultationSending(false);
      nextBtn.textContent = idleLabel;
      showConsultationError((err && err.message) || "That didn't send. Please try again.");
    });
  }

  function showConsultationSuccess() {
    var kind = isMemorialPath() ? 'memorial' : 'sonata';
    var flagged = false;
    try {
      window.localStorage.setItem(CONSULT_SENT_KEY, JSON.stringify({ kind: kind, at: Date.now() }));
      flagged = !!window.localStorage.getItem(CONSULT_SENT_KEY);
    } catch (err) {  }
    if (!flagged) { renderConsultationConfirmation(kind); return; }
    clearStoredState();
    deleteLegacyCookies();
    try {
      var url = new URL(window.location.href);
      ['step', 'package', 'contact_posted'].forEach(function (k) { url.searchParams.delete(k); });
      url.searchParams.set('INT', kind + '-confirmation');
      url.hash = '';
      window.location.replace(url.toString());
    } catch (err) {
      renderConsultationConfirmation(kind);
    }
  }

  function renderConsultationConfirmation(kind) {
    if (kind === 'memorial') {
      showConfirmation(
        "We'll be in touch soon.",
        "A composer will reach out personally to schedule your call, using the availability you shared. Thank you for trusting us with this."
      );
      return;
    }
    showConfirmation(
      'Your consultation request is in.',
      "We've sent your availability to your composer. They'll reach out to confirm a time. Nothing else is needed from you until then."
    );
  }

  function formatNameList(names) {
    var parts = (names || []).map(function (p) { return String(p || '').trim(); }).filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0];
    if (parts.length === 2) return parts[0] + ' and ' + parts[1];
    return parts.slice(0, -1).join(', ') + ', and ' + parts[parts.length - 1];
  }
  function displayName() {
    if (state.forWhom === 'myself') return formatNameList(state.recipientNames) || 'You';
    return formatNameList(state.recipientNames) || 'Someone Special';
  }
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function jsLiteral(v) {
    return JSON.stringify(v)
      .replace(/</g, '\\u003c')
      .replace(/\u2028/g, '\\u2028')
      .replace(/\u2029/g, '\\u2029');
  }
  function putToken(tpl, token, value) {
    return tpl.split('@@' + token + '@@').join(value);
  }

  function fillGiftPreviewTemplate(tpl, countdown) {
    var revealText = state.coverMessage.trim() || computeDefaultCoverMessage();
    var recipientMessage = state.giftNote.trim() ||
      'Your full message will appear here.';
    var composerLetterText = "Your composer's letter will appear here once your piece is finished, explaining how your story shaped it.";
    var composerName = '';

    tpl = putToken(tpl, 'REVEAL_TEXT', jsLiteral(revealText));
    tpl = putToken(tpl, 'RECIPIENT_MESSAGE', jsLiteral(recipientMessage));
    tpl = putToken(tpl, 'COMPOSER_LETTER_TEXT', jsLiteral(composerLetterText));
    tpl = putToken(tpl, 'COMPOSER_NAME', escapeHtml(composerName));
    var canvasEl = document.getElementById('previewCanvas');
    function placeholderUrl(attr) {
      var u = canvasEl ? String(canvasEl.getAttribute(attr) || '').trim() : '';
      return /^https:\/\//i.test(u) ? u : '';
    }
    tpl = putToken(tpl, 'VIDEO_URL', jsLiteral(placeholderUrl('data-placeholder-video')));
    tpl = putToken(tpl, 'SHEET_MUSIC_PDF', jsLiteral(placeholderUrl('data-placeholder-pdf')));
    tpl = putToken(tpl, 'PENDING', countdown ? 'true' : 'false');
    tpl = putToken(tpl, 'COUNTDOWN_MESSAGE', jsLiteral(countdown ? (state.countdownMessage || '').trim() : ''));
    tpl = putToken(tpl, 'INITIAL_TEXT', 'true');
    if (countdown) {
      var cd = countdownTargetDate();
      tpl = putToken(tpl, 'EXPECTED_DATE', jsLiteral(cd.toISOString()));
      tpl = putToken(tpl, 'RECIPIENT_NAME', jsLiteral(formatNameList(state.recipientNames)));
      tpl = putToken(tpl, 'COMMISSIONED_BY', jsLiteral(state.forWhom === 'someone-else' ? (state.giverName || '') : ''));
      tpl = putToken(tpl, 'EXPECTED_DATE_DISPLAY', escapeHtml(cd.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })));
    } else {
      tpl = putToken(tpl, 'EXPECTED_DATE', 'null');
      tpl = putToken(tpl, 'RECIPIENT_NAME', '""');
      tpl = putToken(tpl, 'COMMISSIONED_BY', '""');
      tpl = putToken(tpl, 'EXPECTED_DATE_DISPLAY', 'Soon');
    }
    tpl = putToken(tpl, 'CREATED_DATE', escapeHtml(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })));
    return tpl;
  }

  var previewCanvasFrame = document.getElementById('previewCanvasFrame');
  var previewCanvasWrap = document.querySelector('.wiz-preview-canvas__frame');
  var previewCanvasLoading = document.getElementById('previewCanvasLoading');
  var currentPreviewHtml = null;

  function sizePreviewCanvas() {
    if (!previewCanvasWrap || !previewCanvasFrame) return;
    var scale = previewCanvasWrap.clientWidth / 1280;
    previewCanvasFrame.style.transform = 'scale(' + scale + ')';
    previewCanvasWrap.style.height = Math.round(800 * scale) + 'px';
  }
  window.addEventListener('resize', sizePreviewCanvas);

  function withAutodemoFlag(html) {
    return html.replace('<head>', '<head><script>window.__RIFFLOOM_AUTODEMO__ = true;<\/script>');
  }

  var previewLoadSeq = 0;
  function loadGiftPreview() {
    if (!previewCanvasFrame) return;
    if (previewCanvasLoading) previewCanvasLoading.classList.remove('is-hidden');
    var seq = ++previewLoadSeq;
    getGiftTemplate().then(function (tpl) {
      if (seq !== previewLoadSeq) return;
      var html = fillGiftPreviewTemplate(tpl);
      currentPreviewHtml = html;
      previewCanvasFrame.srcdoc = withAutodemoFlag(html);
      sizePreviewCanvas();
    }).catch(function () {
      if (seq !== previewLoadSeq) return;
      if (previewCanvasLoading) {
        previewCanvasLoading.classList.remove('is-hidden');
        previewCanvasLoading.textContent = "Preview couldn't be loaded. Tap to try again.";
        previewCanvasLoading.style.cursor = 'pointer';
      }
    });
  }
  if (previewCanvasLoading) {
    previewCanvasLoading.addEventListener('click', function () {
      if (/try again/i.test(previewCanvasLoading.textContent)) {
        previewCanvasLoading.textContent = 'Loading preview…';
        previewCanvasLoading.style.cursor = '';
        loadGiftPreview();
      }
    });
  }
  if (previewCanvasFrame) {
    previewCanvasFrame.addEventListener('load', function () {
      if (previewCanvasLoading) previewCanvasLoading.classList.add('is-hidden');
    });
  }

  function countdownTargetDate() {
    var d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + (state.items.sonatina && state.items.sonatina.rush ? 7 : 21));
    return d;
  }
  function localDateStr(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  var countdownField = document.getElementById('countdownField');
  var countdownWhen = document.getElementById('countdownWhen');
  var countdownFrame = document.getElementById('countdownCanvasFrame');
  var countdownWrap = document.querySelector('#countdownCanvas .wiz-preview-canvas__frame');
  var countdownLoading = document.getElementById('countdownCanvasLoading');
  var countdownHtml = null;
  var countdownSeq = 0;

  function sizeCountdownCanvas() {
    if (!countdownWrap || !countdownFrame || !countdownWrap.clientWidth) return;
    var scale = countdownWrap.clientWidth / 1280;
    countdownFrame.style.transform = 'scale(' + scale + ')';
    countdownWrap.style.height = Math.round(800 * scale) + 'px';
  }
  window.addEventListener('resize', sizeCountdownCanvas);

  function countdownOn() {
    return state.pkg !== 'sonata' && !!(state.items.sonatina && state.items.sonatina.countdown);
  }
  function refreshCountdown() {
    if (!countdownField) return;
    countdownField.hidden = !countdownOn();
    if (!countdownOn()) return;
    var rush = !!(state.items.sonatina && state.items.sonatina.rush);
    countdownWhen.innerHTML = 'Your countdown page will count down to <strong>' +
      countdownTargetDate().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) +
      '</strong>, the day your piece is due (' + (rush ? '1 week after your order, with rush delivery).' :
      '3 weeks after your order). Add rush delivery on the package step to bring it forward to 1 week.') +
      ' We\'ll email you its link within 24 hours of your order.';
    sizeCountdownCanvas();
    if (countdownLoading) countdownLoading.classList.remove('is-hidden');
    var seq = ++countdownSeq;
    getGiftTemplate().then(function (tpl) {
      if (seq !== countdownSeq) return;
      countdownHtml = fillGiftPreviewTemplate(tpl, true);
      countdownFrame.srcdoc = countdownHtml;
      sizeCountdownCanvas();
    }).catch(function () {
      if (seq !== countdownSeq || !countdownLoading) return;
      countdownLoading.classList.remove('is-hidden');
      countdownLoading.textContent = "Preview couldn't be loaded. Tap to try again.";
      countdownLoading.style.cursor = 'pointer';
    });
  }
  if (countdownLoading) {
    countdownLoading.addEventListener('click', function () {
      if (/try again/i.test(countdownLoading.textContent)) {
        countdownLoading.textContent = 'Loading preview…';
        countdownLoading.style.cursor = '';
        refreshCountdown();
      }
    });
  }
  function syncCountdownPreviewText() {
    var msg = (state.countdownMessage || '').trim();
    if (!msg || !countdownFrame) return;
    var doc;
    try { doc = countdownFrame.contentDocument; } catch (err) { return; }
    if (!doc || !doc.body) return;
    var paras = msg.split(/\n\s*\n/).map(function (t) { return t.trim(); }).filter(Boolean);
    var nodes = Array.prototype.slice.call(doc.querySelectorAll('p, div'));
    var first = null, second = null;
    nodes.forEach(function (n) {
      if (n.children.length) return;
      var t = (n.textContent || '').trim();
      if (!first && /^It isn.t a song you.ve heard before/i.test(t)) first = n;
      else if (!second && /^When it.s finished, it will appear right here/i.test(t)) second = n;
    });
    if (!first) return;
    first.textContent = paras[0] || '';
    if (second) {
      if (paras[1]) {
        second.textContent = paras.slice(1).join(' ');
      } else {
        second.style.display = 'none';
      }
    }
  }
  if (countdownField) {
    countdownFrame.addEventListener('load', function () {
      if (countdownLoading) countdownLoading.classList.add('is-hidden');
      [0, 150, 500, 1200].forEach(function (ms) { window.setTimeout(syncCountdownPreviewText, ms); });
    });
  }

  function renderPreview() {
    loadGiftPreview();
    refreshCountdown();
  }

  var previewRenderTimer = null;
  function schedulePreviewRender() {
    window.clearTimeout(previewRenderTimer);
    previewRenderTimer = window.setTimeout(function () {
      if (visibleSteps()[currentIndex] === 'page-content') renderPreview();
    }, 500);
  }

  function jumpTo(stepId) {
    if (consultationSending) return;
    var steps = visibleSteps();
    var idx = steps.indexOf(stepId);
    if (idx !== -1) goToStep(idx);
  }

  function reviewRow(title, body, stepId) {
    return '<div class="wiz-review-group">' +
      '<div class="wiz-review-group__head"><p class="wiz-review-group__title">' + title + '</p>' +
        '<button type="button" class="wiz-review-edit" data-jump="' + stepId + '">Edit</button></div>' +
      '<div class="wiz-review-group__body">' + body + '</div></div>';
  }

  function renderReview() {
    var body = document.getElementById('reviewBody');
    var relationshipLabel = state.relationship === 'Other' ? (state.relationshipOther || 'Other') : state.relationship;
    var who = state.forWhom === 'myself' ? 'Myself' : ('Someone else (' + escapeHtml(relationshipLabel || 'Not set') + ')');
    var whoHtml = reviewRow('Who it\'s for', '<strong>' + who + '</strong>' +
      '<br>Song is about: <strong>' + escapeHtml(formatNameList(state.recipientNames) || 'Not set') + '</strong>' +
      (state.forWhom === 'someone-else' ? '<br>From: ' + escapeHtml(state.giverName.trim() || 'Not set') : ''), 'intro');

    var occasionLabel = state.occasion === 'Other' ? (state.occasionOther || 'Other') : state.occasion;
    function clip(text, n) { text = String(text || ''); return escapeHtml(text.length > n ? text.slice(0, n) + '…' : text); }
    var dateText = state.occasionDate ? ' · ' + new Date(state.occasionDate + 'T00:00:00').toLocaleDateString() : (state.noDateYet ? ' · date TBD' : '');
    var detailsHtml = state.pkg === 'sonata'
      ? reviewRow('Occasion & event', escapeHtml(occasionLabel || 'Not set') + dateText +
          '<br><span style="color:var(--ink-45);">' + (String(state.eventDetails || '').trim() ? clip(state.eventDetails, 220) : 'Nothing written yet') + '</span>', 'details')
      : reviewRow('Occasion & story', escapeHtml(occasionLabel || 'Not set') + dateText +
          '<br><span style="color:var(--ink-45);">' + (state.story.trim() ? clip(state.story, 220) : 'No story provided yet') + '</span>' +
          (state.referralSource ? '<br>Heard about us via: ' + escapeHtml(state.referralSource === 'Other' ? (state.referralSourceOther || 'Other') : state.referralSource) : ''), 'details');

    var soundHtml = state.pkg === 'sonata' ? '' : reviewRow('Sound requests',
      state.soundRequest.trim()
        ? '<span style="color:var(--ink-45);">' + (state.soundRequest.length > 220 ? escapeHtml(state.soundRequest.slice(0, 220)) + '…' : escapeHtml(state.soundRequest)) + '</span>'
        : 'None. Your composer will choose.', 'details');

    var def = PACKAGES[state.pkg];
    var extras = def.items.filter(function (i) { return !i.core && state.items[state.pkg][i.id]; }).map(function (i) { return i.label; });
    var pkgPriceDisplay = state.pkg === 'sonata'
      ? 'From $' + amt(PACKAGES.sonata.base) + ' CAD'
      : '$' + amt(pkgPriceAt(state.pkg)) + ' CAD';
    var pkgHtml = reviewRow('Package', '<strong>' + def.label + '</strong>: ' + pkgPriceDisplay +
      (extras.length ? '<br>Includes: ' + extras.join(', ') : ''), 'package');

    var meetHtml = '';
    if (state.pkg === 'sonata') {
      var slotsText = state.meetSlots.filter(function (s) { return s.times.length; })
        .slice().sort(function (a, b) { return a.date < b.date ? -1 : 1; })
        .map(function (s) {
          var slot = slotForEtKey(s.date);
          return escapeHtml(slot ? localSlotLabel(slot) : s.date);
        }).join('<br>');
      meetHtml = reviewRow('Meet your composer', 'Call type: Phone call' +
        '<br>Email: ' + escapeHtml(state.contactValue || 'Not set') +
        '<br>Availability (your time):<br>' + (slotsText || 'Not set'), 'meet');
    }

    var countdownHtml = countdownOn()
      ? reviewRow('Countdown page', 'Yes, counting down to <strong>' +
          countdownTargetDate().toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' }) +
          '</strong> (' + (state.items.sonatina.rush ? '1 week' : '3 weeks') + ' after your order). Its link is emailed to you within 24 hours of your order.' +
          '<br>Message: <span style="color:var(--ink-45);">' + (state.countdownMessage.trim() ? escapeHtml(state.countdownMessage.trim()) : 'Our default wording') + '</span>', 'package')
      : '';

    var totalLabel = state.pkg === 'sonata' ? 'Estimated total' : 'Total due';
    var totalValue = pkgPriceDisplay;
    body.innerHTML = whoHtml + detailsHtml + soundHtml + pkgHtml + countdownHtml + meetHtml +
      '<div class="wiz-review-total"><span class="wiz-pkg-total__label">' + totalLabel + '</span><span class="wiz-pkg-total__value">' + totalValue + '</span></div>';

    body.querySelectorAll('[data-jump]').forEach(function (btn) {
      btn.addEventListener('click', function () { jumpTo(btn.dataset.jump); });
    });
  }

  function variantId(key) { return CATALOG[key] && CATALOG[key].id; }

  function shopRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function buildOrderProperties() {
    var relLabel = state.relationship === 'Other' ? (state.relationshipOther || '') : (state.relationship || '');
    var occLabel = state.occasion === 'Other' ? (state.occasionOther || '') : (state.occasion || '');
    var referral = state.referralSource === 'Other' ? (state.referralSourceOther || '') : (state.referralSource || '');
    var props = {
      'Song is about': formatNameList(state.recipientNames),
      'Occasion': occLabel,
      'Occasion date': state.noDateYet ? 'No date yet'
        : (state.occasionDate ? new Date(state.occasionDate + 'T00:00:00').toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : ''),
      'Delivery date': state.pkg === 'sonata' ? '' : deliveryDateLabel(),
      '_occasion_date': state.noDateYet ? '' : (state.occasionDate || ''),
      '_for_whom': state.forWhom || '',
      '_relationship': relLabel,
      '_from_name': state.giverName || '',
      '_story': state.story || '',
      '_cover_message': state.coverMessage || '',
      '_gift_note': state.giftNote || '',
      '_sound_request': state.soundRequest || '',
      '_referral_source': referral,
      '_promo_code': state.promoCode || '',
      '_keep_private': state.keepPrivate ? 'yes' : '',
      '_countdown': countdownOn() ? 'yes' : '',
      '_countdown_date': countdownOn() ? localDateStr(countdownTargetDate()) : '',
      '_countdown_message': countdownOn() ? (state.countdownMessage || '').trim() : '',
      // The template the customer previewed. The order webhook only uses these to pick one of
      // the published releases in unwrap_t_template_releases; they are never trusted as given.
      '_template_path': GIFT_TEMPLATE_URL,
      '_template_integrity': GIFT_TEMPLATE_INTEGRITY,
      '_source': 'start-flow'
    };
    Object.keys(props).forEach(function (k) {
      props[k] = String(props[k] == null ? '' : props[k]);
      if (props[k] === '' && k.charAt(0) !== '_') delete props[k];
    });
    return props;
  }

  var submitErrorEl = null;
  function showSubmitError(message) {
    if (!submitErrorEl) {
      submitErrorEl = document.createElement('p');
      submitErrorEl.className = 'wiz-field__error';
      submitErrorEl.setAttribute('role', 'alert');
    }
    var step = document.querySelector('.wiz-step.is-active');
    if (step && submitErrorEl.parentNode !== step) step.appendChild(submitErrorEl);
    setTextWithContactLink(submitErrorEl, message);
    submitErrorEl.style.display = message ? 'block' : 'none';
  }

  function setSubmitting(on) {
    submitInFlight = on;
    window.clearTimeout(cartPush.timer);
    nextBtn.disabled = on;
    if (!on) renderFooter();
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setSubmitting(false);
  });

  var CART_EXTRAS = ['rush', 'extraMinute', 'slideshow', 'countdown'];

  function cartRequest(path, body) {
    return fetch(shopRoot() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body || {})
    }).then(function (res) {
      if (!res.ok) throw new Error(path + ' failed: HTTP ' + res.status);
      return res.json().catch(function () { return null; });
    });
  }

  function sameProps(a, b) {
    function norm(o) {
      var out = {};
      Object.keys(o || {}).forEach(function (k) {
        var v = String(o[k] == null ? '' : o[k]);
        if (v !== '') out[k] = v;
      });
      return out;
    }
    var x = norm(a), y = norm(b), kx = Object.keys(x);
    if (kx.length !== Object.keys(y).length) return false;
    return kx.every(function (k) { return x[k] === y[k]; });
  }

  function orderIsComplete() {
    if (!state.forWhom || !state.occasion) return false;
    if (state.occasion === 'Other' && !state.occasionOther.trim()) return false;
    if (!state.recipientNames.some(function (n) { return n.trim(); })) return false;
    if (!state.referralSource) return false;
    if (state.referralSource === 'Other' && !state.referralSourceOther.trim()) return false;
    if (!state.occasionDate && !state.noDateYet) return false;
    if (!isMemorialPath() && state.story.trim().length < 20) return false;
    return true;
  }

  function pushStateToCart() {
    return fetch(shopRoot() + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart.js failed: HTTP ' + res.status);
        return res.json();
      })
      .then(function (cart) {
        var items = cart.items || [];
        var byVariant = {};
        items.forEach(function (it) { byVariant[String(it.variant_id)] = it; });
        var chain = Promise.resolve();

        if (state.pkg !== 'sonatina') {
          if (items.length) chain = chain.then(function () { return cartRequest('cart/clear.js'); });
          return chain.then(function () { state.handedOff = false; writeStoredState(state); });
        }

        var son = byVariant[String(variantId('sonatina'))];
        if (!son) { state.handedOff = false; writeStoredState(state); return; }

        if (orderIsComplete()) {
          var props = buildOrderProperties();
          if (!sameProps(son.properties, props)) {
            chain = chain.then(function () { return cartRequest('cart/change.js', { id: son.key, quantity: 1, properties: props }); });
          }
        }
        CART_EXTRAS.forEach(function (k) {
          var vid = variantId(k);
          if (!vid) return;
          var line = byVariant[String(vid)];
          var want = !!(state.items.sonatina && state.items.sonatina[k]);
          if (want && !line) chain = chain.then(function () { return cartRequest('cart/add.js', { items: [{ id: vid, quantity: 1 }] }); });
          else if (want && line && line.quantity !== 1) chain = chain.then(function () { return cartRequest('cart/change.js', { id: line.key, quantity: 1 }); });
          else if (!want && line) chain = chain.then(function () { return cartRequest('cart/change.js', { id: line.key, quantity: 0 }); });
        });
        return chain;
      });
  }

  function runCartPush() {
    if (!state.handedOff || submitInFlight) return;
    if (cartPush.running) { cartPush.again = true; return; }
    cartPush.running = true;
    cartPush.current = pushStateToCart()
      .catch(function (err) { console.error('[Riffloom] Could not update the cart:', err); })
      .then(function () {
        cartPush.running = false;
        cartPush.current = null;
        if (cartPush.again) { cartPush.again = false; runCartPush(); }
      });
  }

  function scheduleCartPush() {
    if (!state.handedOff || submitInFlight) return;
    window.clearTimeout(cartPush.timer);
    cartPush.timer = window.setTimeout(runCartPush, 350);
  }

  function afterCartPush() {
    window.clearTimeout(cartPush.timer);
    return cartPush.current || Promise.resolve();
  }

  function submitForm() {
    showSubmitError('');

    if (window.RIFFLOOM_SONATINA_SOLD_OUT) {
      showSubmitError("Sonatinas are sold out right now, so we can't add this to your cart. Please join the waitlist and we'll let you know when we have room.");
      var wl = document.querySelector('[data-waitlist-open]');
      if (wl) wl.click();
      return;
    }

    if (CATALOG_ERRORS.length || !variantId('sonatina')) {
      console.error('[Riffloom] Cannot start checkout: missing Shopify product data for ' + (CATALOG_ERRORS.join(', ') || 'sonatina') + '.');
      showSubmitError("Sorry, we couldn't add your order to the cart. Please try again shortly or [contact us].");
      return;
    }

    var items = [{ id: variantId('sonatina'), quantity: 1, properties: buildOrderProperties() }];
    ['rush', 'extraMinute', 'slideshow', 'countdown'].forEach(function (extraId) {
      if (state.items.sonatina[extraId]) items.push({ id: variantId(extraId), quantity: 1 });
    });

    setSubmitting(true);
    var root = shopRoot();

    afterCartPush().then(function () { return fetch(root + 'cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' } }); })
      .then(function (res) {
        if (!res.ok) throw new Error('cart/clear failed: HTTP ' + res.status);
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) {
          return res.text().then(function (t) { throw new Error('cart/add failed: HTTP ' + res.status + ' ' + t); });
        }
        state.handedOff = true;
        window.clearTimeout(saveTimer);
        writeStoredState(state);
        window.location.href = root + 'cart?INT=' + encodeURIComponent(state.pkg ? state.pkg + '-cart' : 'cart');
      })
      .catch(function (err) {
        console.error('[Riffloom] Could not add the order to the cart:', err);
        setSubmitting(false);
        showSubmitError("Sorry, we couldn't add your order to the cart. Please check your connection and try again, or [contact us].");
      });
  }

  function validateStep(id) {
    if (id === 'intro') return validateIntro();
    if (id === 'details') return validateDetails();
    if (id === 'page-content') return validatePageContent();
    if (id === 'meet') return validateMeet();
    if (id === 'package') return validatePackage();
    return true;
  }

  refreshVisibility();
  updateMelodyPreview();
  updateGiftNoteCopy();
  updateStoryHint();
  updateMeetCopy();
  revealStoryRestFields();
  updateRelationshipVisibility();
  renderFooter();

  var returnedFromChallenge = /[?&]contact_posted=true(&|$)/.test(location.search) &&
    window.location.hash === '#sonataSubmissionForm';
  var sentKind = null;
  (function () {
    var m = /^(memorial|sonata)-confirmation$/.exec(new URLSearchParams(window.location.search).get('INT') || '');
    if (!m) return;
    try {
      var flag = JSON.parse(window.localStorage.getItem(CONSULT_SENT_KEY) || 'null');
      if (flag && flag.kind === m[1]) sentKind = m[1];
    } catch (e) {}
  })();
  if (returnedFromChallenge) {
    showConsultationSuccess();
  } else if (sentKind) {
    if (sentKind === 'memorial') state.occasion = 'Memorial'; else state.pkg = 'sonata';
    renderConsultationConfirmation(sentKind);
  } else {
    goToStep(0);
  }

  (function () {
    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('step') || params.get('INT');
    if (wanted) jumpTo(wanted.replace(/^(memorial|sonata|sonatina)-/, ''));
  })();
})();

(function () {
  window.riffloomFlowSynced = Promise.resolve();
  if (document.getElementById('wizForm')) return;

  var KEY = 'riffloomStartFlow_v3';
  var EXTRAS = ['rush', 'extraMinute', 'slideshow', 'countdown'];
  var timer = null;

  function readEntry() {
    try { return JSON.parse(window.localStorage.getItem(KEY) || 'null'); } catch (e) { return null; }
  }

  function syncFromCart() {
    var first = readEntry();
    var cat = window.RIFFLOOM_CATALOG;
    if (!first || !first.state || !first.state.handedOff || !cat || !cat.sonatina || !cat.sonatina.id) {
      return Promise.resolve();
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var entry = readEntry();
        if (!entry || !entry.state || !entry.state.handedOff) return;
        var st = entry.state;

        var present = {};
        (cart.items || []).forEach(function (it) { present[String(it.variant_id)] = true; });
        function inCart(key) { return !!(cat[key] && cat[key].id && present[String(cat[key].id)]); }

        st.items = st.items || {};
        st.items.sonatina = st.items.sonatina || {};
        var items = st.items.sonatina;
        var changed = false;

        if (!inCart('sonatina')) {
          if (st.pkg !== null) { st.pkg = null; changed = true; }
          if (st.pkgTouched) { st.pkgTouched = false; changed = true; }
          EXTRAS.forEach(function (k) { if (items[k]) { items[k] = false; changed = true; } });
          st.handedOff = false;
          changed = true;
        } else {
          EXTRAS.forEach(function (k) {
            var want = inCart(k);
            if (!!items[k] !== want) { items[k] = want; changed = true; }
          });
        }

        if (changed) {
          try { window.localStorage.setItem(KEY, JSON.stringify({ savedAt: entry.savedAt, state: st })); } catch (e) {}
        }
      })
      .catch(function () {});
  }

  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(syncFromCart, 200);
  }

  window.riffloomFlowSynced = syncFromCart();

  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input) {
      var p = origFetch.apply(this, arguments);
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) p.then(schedule, function () {});
      } catch (e) {}
      return p;
    };
  }
})();

/* Hero video: plays on desktop and phones; tablets keep the stock photo and never download the video. */
(function heroVideo() {
  'use strict';

  var video = document.querySelector('[data-hero-video]');
  if (!video) return;
  var figure = video.closest('.hero__figure');
  var src = video.getAttribute('data-src');
  if (!figure || !src) return;

  // Respect reduced motion: keep the still photo.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var tablet = window.matchMedia('(min-width: 810px) and (max-width: 1199.98px)');
  var onScreen = true;

  function markReady() { figure.classList.add('is-video-ready'); }
  video.addEventListener('loadeddata', markReady);
  video.addEventListener('playing', markReady);
  // The inline script in the homepage may have started the video before this file ran.
  if (video.readyState >= 2) markReady();

  function play() {
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  function sync() {
    if (tablet.matches) {
      video.pause();
      return;
    }
    figure.classList.add('has-video');
    if (!video.getAttribute('src')) video.setAttribute('src', src);
    if (onScreen) play();
  }

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      onScreen = entries[0].isIntersecting;
      if (tablet.matches || !video.getAttribute('src')) return;
      if (onScreen) play(); else video.pause();
    }).observe(figure);
  }

  sync();
  if (tablet.addEventListener) tablet.addEventListener('change', sync);
  else if (tablet.addListener) tablet.addListener(sync);
})();